// import React, { useState, useEffect } from "react";
// import {
//     Box, Typography, Button, TextField, MenuItem, Select,
//     Snackbar, Alert, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions,
// } from "@mui/material";
// import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
// import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
// import { useAuth } from "../context/AuthContext";
// import axios from "axios";
// import ExcelJS from "exceljs";

// // ── Design Tokens ─────────────────────────────────────────────────────────────
// const NAVY     = "#0D2137";
// const STEEL    = "#1B4FBB";
// const STEEL_LT = "#EBF2FF";
// const PAGE_BG  = "#F4F6F9";
// const CARD     = "#FFFFFF";
// const BORDER   = "#E2E8F0";
// const TH_BG    = "#F7F9FC";
// const T1       = "#1A202C";
// const T2       = "#4A5568";
// const T3       = "#718096";
// const WHITE    = "#FFFFFF";

// // ── Styles ────────────────────────────────────────────────────────────────────
// const btnPrimary = {
//     background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
//     textTransform: "none", px: 2.5, height: 36, whiteSpace: "nowrap",
//     "&:hover": { background: "#1640A0" },
//     "&:disabled": { background: BORDER, color: T3 },
// };
// const btnHeaderSolid = {
//     color: NAVY, background: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 700,
//     textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
//     "&:hover": { background: "#E8EDF5" },
//     "&:disabled": { background: "rgba(255,255,255,0.25)", color: "rgba(13,33,55,0.35)" },
// };
// const inputSx = {
//     "& .MuiOutlinedInput-root": {
//         borderRadius: "4px", background: CARD, fontSize: 13,
//         "& fieldset": { borderColor: BORDER },
//         "&:hover fieldset": { borderColor: STEEL },
//         "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//     },
// };

// // ── Constants ─────────────────────────────────────────────────────────────────
// const GST_REPORT_OPTIONS = [
//     { value: "gstr1",  label: "GSTR-1"  },
//     { value: "gstr2b", label: "GSTR-2B" },
//     { value: "gstr3b", label: "GSTR-3B" },
// ];

// const getFinancialYearDates = () => {
//     const now = new Date();
//     const month = now.getMonth();
//     const year  = now.getFullYear();
//     const fyStart = month >= 3 ? year : year - 1;
//     const fromDate = `${fyStart}-04-01`;
//     const toDate   = `${fyStart + 1}-03-31`;
//     return { fromDate, toDate };
// };

// const getCurrentMonthDates = () => {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = now.getMonth();
//     const fromDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;
//     const lastDay = new Date(year, month + 1, 0).getDate();
//     const toDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
//     return { fromDate, toDate };
// };

// // ── Excel Helpers ─────────────────────────────────────────────────────────────
// const SUMMARY_BG_ARGB = "FF538ED5";
// const HEADER_BG_ARGB  = "FFF8CBAC";

// const fmtDate = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr);
//     if (isNaN(d.getTime())) return String(dateStr);
//     return d;
// };

// const cessVal = (v) => (!v || Number(v) === 0) ? "" : Number(v);

// const stateLabel = (r) => {
//     const code  = r.StateCode || "";
//     const state = r.State || r.state || "";
//     return code ? `${code}-${state}` : state;
// };

// const SUMMARY_TEXTS = {
//     b2b:    "Summary For B2B(4)",
//     b2cl:   "Summary For B2CL(5)",
//     b2cs:   "Summary For B2CS(6)",
//     cdnr:   "Summary For CDNR(9B)",
//     cdnur:  "Summary For CDNUR(9B)",
//     exp:    "Summary For EXP(6)",
//     at:     "Summary For Advance Received (11B)",
//     atadj:  "Summary For Advance Adjusted (11B)",
//     exemp:  "Summary For Nil rated, exempted and non GST outward supplies (8)",
//     hsnb2b: "Summary For HSN(12)",
//     hsnb2c: "Summary For HSN(12)",
//     docs:   "Summary of documents issued during the tax period(13)",
//     "b2b-2b":    "Summary For B2B Purchases(4A)",
//     "b2c-2b":    "Summary For B2C Purchases(4C)",
//     "hsn-2b":    "Summary For HSN(14)",
//     "docs-2b":   "Summary of documents received during the tax period(13B)",
//     "outward":   "Outward Supplies",
//     "inward":    "Inward Supplies",
//     "taxsummary": "Tax Summary",
// };

// const SHEET_HEADERS = {
//     b2b: [
//         "GSTIN/UIN of Recipient", "Receiver Name", "Invoice Number", "Invoice date",
//         "Invoice Value", "Place Of Supply", "Reverse Charge",
//         "Applicable % of Tax Rate", "Invoice Type", "E-Commerce GSTIN",
//         "Rate", "Taxable Value", "Cess Amount",
//     ],
//     b2cl: [
//         "Invoice Number", "Invoice date", "Invoice Value", "Place Of Supply",
//         "Applicable % of Tax Rate", "Rate", "Taxable Value", "Cess Amount", "E-Commerce GSTIN",
//     ],
//     b2cs: [
//         "Type", "Place Of Supply", "Applicable % of Tax Rate",
//         "Rate", "Taxable Value", "Cess Amount", "E-Commerce GSTIN",
//     ],
//     cdnr: [
//         "GSTIN/UIN of Recipient", "Receiver Name", "Note Number", "Note Date",
//         "Note Type", "Place Of Supply", "Reverse Charge", "Note Supply Type",
//         "Note Value", "Applicable % of Tax Rate", "Rate", "Taxable Value", "Cess Amount",
//     ],
//     cdnur: [
//         "UR Type", "Note Number", "Note Date", "Note Type", "Place Of Supply",
//         "Note Value", "Applicable % of Tax Rate", "Rate", "Taxable Value", "Cess Amount",
//     ],
//     exp: [
//         "Export Type", "Invoice Number", "Invoice date", "Invoice Value",
//         "Port Code", "Shipping Bill Number", "Shipping Bill Date",
//         "Rate", "Taxable Value", "Cess Amount",
//     ],
//     at:    ["Place Of Supply", "Applicable % of Tax Rate", "Rate", "Gross Advance Received", "Cess Amount"],
//     atadj: ["Place Of Supply", "Applicable % of Tax Rate", "Rate", "Gross Advance adjusted", "Cess Amount"],
//     exemp: [
//         "Description", "Nil Rated Supplies",
//         "exempted (other than nil rated/non GST supply )", "Non-GST supplies",
//     ],
//     hsn: [
//         "HSN", "Description", "UQC", "Total Quantity", "Total Value",
//         "Rate", "Taxable Value", "Integrated Tax Amount",
//         "Central Tax Amount", "State/UT Tax Amount", "Cess Amount",
//     ],
//     docs: ["Nature of Document", "Sr. No. From", "Sr. No. To", "Total Number", "Cancelled"],
//     "b2b-2b": [
//         "GSTIN/UIN of Supplier", "Supplier Name", "Invoice Number", "Invoice date",
//         "Invoice Value", "Place Of Supply", "Reverse Charge",
//         "Applicable % of Tax Rate", "Invoice Type", "E-Commerce GSTIN",
//         "Rate", "Taxable Value", "Cess Amount",
//     ],
//     "b2c-2b": [
//         "Type", "Place Of Supply", "Applicable % of Tax Rate",
//         "Rate", "Taxable Value", "Cess Amount", "E-Commerce GSTIN",
//     ],
//     "hsn-2b": [
//         "HSN", "Description", "UQC", "Total Quantity", "Total Value",
//         "Rate", "Taxable Value", "Integrated Tax Amount",
//         "Central Tax Amount", "State/UT Tax Amount", "Cess Amount",
//     ],
//     "docs-2b": ["Nature of Document", "Sr. No. From", "Sr. No. To", "Total Number", "Cancelled"],
//     outward: ["Supply Type", "Taxable Amount", "CGST", "SGST", "IGST", "Cess"],
//     inward: ["Supply Type", "Purchase Taxable", "Purchase CGST", "Purchase SGST", "Purchase IGST", "Purchase Cess", "Credit Note Taxable", "Credit Note CGST", "Credit Note SGST", "Credit Note IGST", "Credit Note Cess"],
//     taxsummary: ["Category", "CGST", "SGST", "IGST", "Cess"],
// };

// const addSheet = (wb, sheetName, summaryText, headers, dataRows) => {
//     const ws = wb.addWorksheet(sheetName);

//     const c1 = ws.getCell("A1");
//     c1.value     = summaryText;
//     c1.fill      = { type: "pattern", pattern: "solid", fgColor: { argb: SUMMARY_BG_ARGB } };
//     c1.font      = { color: { argb: "FFFFFFFF" }, bold: true, size: 11 };
//     c1.alignment = { vertical: "middle" };

//     const headerRow = ws.getRow(4);
//     headers.forEach((h, i) => {
//         const cell       = headerRow.getCell(i + 1);
//         cell.value       = h;
//         cell.fill        = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_BG_ARGB } };
//         cell.font        = { bold: true, size: 10 };
//         cell.alignment   = { horizontal: "center", vertical: "middle", wrapText: true };
//     });
//     headerRow.height = 32;

//     dataRows.forEach((row, idx) => {
//         const wsRow = ws.getRow(idx + 5);
//         row.forEach((val, col) => {
//             const cell = wsRow.getCell(col + 1);
//             if (val instanceof Date) {
//                 cell.value  = val;
//                 cell.numFmt = "DD-MMM-YY";
//             } else {
//                 cell.value = (val === "" || val == null) ? "" : val;
//             }
//         });
//     });

//     ws.columns.forEach((col, i) => {
//         let maxLen = headers[i] ? headers[i].length : 10;
//         dataRows.forEach(row => {
//             const v = row[i];
//             if (v != null && String(v).length > maxLen) maxLen = String(v).length;
//         });
//         col.width = Math.min(Math.max(maxLen + 3, 12), 48);
//     });
// };

// // ── Data row mappers ──────────────────────────────────────────────────────────

// const mapB2B = (rows) => (rows || []).map(r => [
//     r.GSTNo        || "",
//     r.ReceiverName || "",
//     r.InvoiceNumber || "",
//     fmtDate(r.InvoiceDate),
//     r.InvoiceValue || 0,
//     stateLabel(r),
//     "",
//     "",
//     "Regular",
//     "",
//     r.gstrate      || 0,
//     r.TaxableAmt   || 0,
//     cessVal(r.cessamt),
// ]);

// const mapB2CL = (rows) => (rows || []).map(r => [
//     r.BillNumber || "",
//     fmtDate(r.BillDate),
//     r.BillAmt    || 0,
//     stateLabel(r),
//     "",
//     r.IGST       || 0,
//     r.TaxableAmt || 0,
//     cessVal(r.CessAmt),
//     "",
// ]);

// const mapB2CS = (rows) => (rows || []).map(r => [
//     "OE",
//     stateLabel(r),
//     "",
//     r.IGST || r.CGST || 0,
//     r.TaxableAmt || 0,
//     cessVal(r.CessAmt),
//     "",
// ]);

// const mapCDNR = (b2bRows) => (b2bRows || []).map(r => [
//     r.GSTNo        || "",
//     r.ReceiverName || "",
//     r.InvoiceNumber || "",
//     fmtDate(r.InvoiceDate),
//     "C",
//     stateLabel(r),
//     "",
//     "B2B",
//     r.InvoiceValue || 0,
//     "",
//     r.gstrate      || 0,
//     r.TaxableAmt   || 0,
//     cessVal(r.cessamt),
// ]);

// const mapCDNUR = (b2clRows) => (b2clRows || []).map(r => [
//     "B2CL",
//     r.BillNumber || "",
//     fmtDate(r.BillDate),
//     "C",
//     stateLabel(r),
//     r.BillAmt    || 0,
//     "",
//     r.IGST       || 0,
//     r.TaxableAmt || 0,
//     cessVal(r.CessAmt),
// ]);

// const mapEXP = (rows) => (rows || []).map(r => [
//     r.GSTCategory === "WPAY" ? "WPAY" : "WOPAY",
//     r.BillNumber || "",
//     fmtDate(r.BillDate),
//     r.BillAmt    || 0,
//     "",
//     "",
//     "",
//     r.IGst > 0 ? r.IGst : ((r.CGst || 0) + (r.SGst || 0)),
//     r.TaxableAmt || 0,
//     cessVal(r.CessAmt),
// ]);

// const mapEXEMP = (rows) => (rows || []).map(r => [
//     r.Description           || "",
//     r["Nil Rated Supplies"] || 0,
//     r["Exempted"]           || 0,
//     r["Non-GST supplies"]   || 0,
// ]);

// const mapHSN = (rows) => (rows || []).map(r => [
//     r.HSNNO          || "",
//     r.HSNDescription || "",
//     "",
//     r.QTY            || 0,
//     r.BILLAMT        || 0,
//     r.IGSTRate > 0 ? r.IGSTRate : ((r.CGSTRate || 0) + (r.SGSTRate || 0)),
//     r.TAXABLEAMT     || 0,
//     r.IGSTAMT        || 0,
//     r.CGSTAMT        || 0,
//     r.SGSTAMT        || 0,
//     cessVal(r.CESSAMT),
// ]);

// const mapDOCS = (rows) => (rows || []).map(r => [
//     r.NatureofDocument || "",
//     r.FromNo           || "",
//     r.ToNo             || "",
//     r.TotalCount       || 0,
//     r.Cancelled        || 0,
// ]);

// const mapB2BPurchases = (rows) => (rows || []).map(r => [
//     r.GSTNo            || "",
//     r.SupplierName     || "",
//     r.InvoiceNumber    || "",
//     fmtDate(r.InvoiceDate),
//     r.InvoiceValue     || 0,
//     stateLabel(r),
//     "",
//     "",
//     "Regular",
//     "",
//     r.gstrate          || 0,
//     r.TaxableAmt       || 0,
//     cessVal(r.cessamt),
// ]);

// const mapB2CPurchases = (rows) => (rows || []).map(r => [
//     "OE",
//     stateLabel(r),
//     "",
//     r.IGST || r.CGST || 0,
//     r.TaxableAmt || 0,
//     cessVal(r.CessAmt),
//     "",
// ]);

// const mapOutwardSupplies = (rows) => (rows || []).map(r => [
//     r.SupplyType       || "",
//     r.TaxableAmt       || 0,
//     r.CGST             || 0,
//     r.SGST             || 0,
//     r.IGST             || 0,
//     cessVal(r.Cess),
// ]);

// const mapInwardSupplies = (rows) => (rows || []).map(r => [
//     r.SupplyType           || "",
//     r.PurchaseTaxableAmt   || 0,
//     r.PurchaseCGST         || 0,
//     r.PurchaseSGST         || 0,
//     r.PurchaseIGST         || 0,
//     cessVal(r.PurchaseCess),
//     r.CreditNoteTaxableAmt || 0,
//     r.CreditNoteCGST       || 0,
//     r.CreditNoteSGST       || 0,
//     r.CreditNoteIGST       || 0,
//     cessVal(r.CreditNoteCess),
// ]);

// const mapTaxSummary = (rows) => (rows || []).map(r => [
//     r.Category || "",
//     r.CGST     || 0,
//     r.SGST     || 0,
//     r.IGST     || 0,
//     cessVal(r.Cess),
// ]);

// // ── GSTR-3B Single Sheet Creator ──────────────────────────────────────────────
// // Matches the reference template exactly:
// //   - No colors, no borders, no bold, no special alignment
// //   - Plain font size 11, Calibri
// //   - Column B width = 137, Column C width = 18.71
// //   - All data placed at the exact same row numbers as the reference file
// //   - Section 3.2 unregistered data rows start at row 24
// //     (if more than 1 data row, subsequent rows push 3.2 sub-sections down
// //      but all sections from 3.1 onward stay at their fixed row numbers)
// // NOTE: Because the reference has fixed row numbers for every section,
// //   the 3.2 unregistered data is written starting row 24, and only row 24
// //   is used for the first entry — extra entries overflow below row 24
// //   but all other sections (4, 5, 6.1 etc.) remain at their fixed positions.

// const addGSTR3BSheet = (wb, data, fromDate, toDate) => {
//     const ws = wb.addWorksheet("GSTR-3B");

//     // ── Helper: safe number ──────────────────────────────────────────────────
//     const n = (v) => Number(v) || 0;

//     // ── Helper: normalize tax column names (IGSTAMT → IGST, IgstAmt → IGST, etc) ──
//     const normalizeTaxData = (obj) => {
//         if (!obj) return {};
//         const getSafeValue = (value) => (value !== null && value !== undefined ? value : 0);
//         return {
//             TaxableAmt: getSafeValue(obj.TaxableAmt),
//             IGST: getSafeValue(
//                 obj.IGST || obj.IGSTAMT || obj.IgstAmt || obj.IGSTAmt
//             ),
//             CGST: getSafeValue(
//                 obj.CGST || obj.CGSTAMT || obj.CgstAmt || obj.CGSTAmt
//             ),
//             SGST: getSafeValue(
//                 obj.SGST || obj.SGSTAMT || obj.SgstAmt || obj.SGSTAmt
//             ),
//             Cess: getSafeValue(
//                 obj.Cess || obj.CESSAMT || obj.CessAmt || obj.GSTCEssAmt
//             ),
//             UTGST: getSafeValue(
//                 obj.UTGST || obj.UTGSTAMT || obj.UtgstAmt || obj.UTGSTAmt
//             ),
//         };
//     };

//     // plain cell setter — no color, no bold, no border, size 11 Calibri
//     const s = (coord, value) => {
//         const cell = ws.getCell(coord);
//         cell.value = (value === null || value === undefined) ? "" : value;
//         cell.font  = { name: "Calibri", size: 11 };
//     };

//     // ── Column widths — exactly as in reference ──────────────────────────────
//     ws.getColumn("A").width = 5;
//     ws.getColumn("B").width = 137;
//     ws.getColumn("C").width = 18.71;
//     ws.getColumn("D").width = 18.71;
//     ws.getColumn("E").width = 18.71;
//     ws.getColumn("F").width = 18.71;
//     ws.getColumn("G").width = 18.71;
//     ws.getColumn("H").width = 18.71;
//     ws.getColumn("I").width = 18.71;
//     ws.getColumn("J").width = 18.71;
//     ws.getColumn("K").width = 18.71;

//     // ── Company info from API response (companymaster) ───────────────────────
//     const company = data.company || {};

//     // ── Extract data sections ────────────────────────────────────────────────
//     const s31  = data.section_31  || {};
//     const s32  = data.section_32  || {};
//     const s4   = data.section_4   || {};
//     const s5   = data.section_5   || {};
//     const s61  = data.section_61  || {};
//     const zeroRatedDetails = s31.b_zero_rated?.by_transaction_type || [];
//     const inwardSupplies = data.inward_supplies || {};
//     const itcA1 = data.itc_purchase_a1 || {};
//     const itcA2 = data.itc_purchase_a2 || {};
//     const itcA4 = data.itc_purchase_a4 || {};
//     const itcA5 = data.itc_purchase_a5 || {};

//     const itcAvail   = s4.itc_available   || {};
//     const itcRev     = s4.itc_reversed    || {};
//     const itcInelig  = s4.ineligible_itc  || {};
//     const allOtherITC = itcAvail.all_other_itc || {};

//     // Helper: aggregate taxes from row data if totals are missing
//     const aggregateTaxesFromRows = (rows) => {
//         if (!rows || !Array.isArray(rows) || rows.length === 0) return {};
//         let result = { TaxableAmt: 0, IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
//         rows.forEach(r => {
//             const normalized = normalizeTaxData(r);
//             result.TaxableAmt += n(normalized.TaxableAmt);
//             result.IGST += n(normalized.IGST);
//             result.CGST += n(normalized.CGST);
//             result.SGST += n(normalized.SGST);
//             result.Cess += n(normalized.Cess);
//         });
//         return result;
//     };

//     // Helper: calculate ITC totals from purchase query data
//     const calculateITCTotals = (itcData) => {
//         if (!itcData) return { IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
//         // If data has rows, aggregate them
//         if (itcData.rows && Array.isArray(itcData.rows)) {
//             return aggregateTaxesFromRows(itcData.rows);
//         }
//         // Otherwise, try to use direct properties (normalized)
//         return normalizeTaxData(itcData);
//     };

//     // Calculate ITC totals from query data
//     const itcA1Totals = calculateITCTotals(itcA1);
//     const itcA2Totals = calculateITCTotals(itcA2);
//     const itcA4Totals = calculateITCTotals(itcA4);
//     const itcA5Totals = calculateITCTotals(itcA5);

//     // Helper: sum tax values from multiple sources
//     const sumTaxValues = (...sources) => ({
//         IGST: sources.reduce((sum, src) => sum + n(src?.IGST), 0),
//         CGST: sources.reduce((sum, src) => sum + n(src?.CGST), 0),
//         SGST: sources.reduce((sum, src) => sum + n(src?.SGST), 0),
//         Cess: sources.reduce((sum, src) => sum + n(src?.Cess), 0),
//     });

//     // (A) ITC Available - sum of all available ITC sources
//     const itcAvailTotal = sumTaxValues(
//         itcA1Totals,
//         itcA2Totals,
//         { IGST: (itcAvail.reverse_charge || {}).IGST, CGST: (itcAvail.reverse_charge || {}).CGST, SGST: (itcAvail.reverse_charge || {}).SGST, Cess: (itcAvail.reverse_charge || {}).Cess },
//         itcA4Totals,
//         itcA5Totals
//     );

//     // (B) ITC Reversed - sum of all reversed ITC
//     const itcRevTotal = sumTaxValues(
//         itcRev.rule_42_43,
//         itcRev.others
//     );

//     // (C) Net ITC Available = (A) - (B)
//     const netITCIGST = n(itcAvailTotal.IGST - itcRevTotal.IGST);
//     const netITCCGST = n(itcAvailTotal.CGST - itcRevTotal.CGST);
//     const netITCSGST = n(itcAvailTotal.SGST - itcRevTotal.SGST);
//     const netITCCess = n(itcAvailTotal.Cess - itcRevTotal.Cess);

//     // Helper: display value only if > 0, otherwise empty string
//     const displayValue = (val) => (n(val) > 0 ? n(val) : "");

//     // Month/Year display from toDate
//     const toDateObj = new Date(toDate);
//     const monthYear = toDateObj.toLocaleString("en-IN", { month: "long", year: "numeric" });

//     // Financial year string
//     const fyStart = new Date(fromDate).getFullYear();
//     const fyEnd   = new Date(toDate).getFullYear();
//     const fyStr   = `${fyStart}-${fyEnd}`;

//     // Section data - extract totals from structure and normalize column names
//     // If totals are missing/zero, calculate from row data
//     const getOutwardTotals = (section) => {
//         let total = normalizeTaxData((section?.total) || section || {});
//         if ((n(total.IGST) === 0 && n(total.CGST) === 0 && n(total.SGST) === 0) && section?.by_transaction_type?.length > 0) {
//             total = aggregateTaxesFromRows(section.by_transaction_type);
//         }
//         return total;
//     };

//     const outA = getOutwardTotals(s31.a_outward_taxable);
//     const outB = getOutwardTotals(s31.b_zero_rated);
//     const outC = normalizeTaxData((s31.c_nil_exempt?.total) || (s31.c_nil_exempt) || {});
//     const outD = normalizeTaxData(s31.d_reverse_charge || {});
//     const outE = normalizeTaxData((s31.e_non_gst?.total) || (s31.e_non_gst) || {});

//     // Extract outward tax amounts for section 6.1
//     const outwardIGST = n(outA.IGST);
//     const outwardCGST = n(outA.CGST);
//     const outwardSGST = n(outA.SGST);
//     const outwardCess = n(outA.Cess);

//     // ── ROW 5: Name / Month ──────────────────────────────────────────────────
//     s("A5", "Name");
//     s("B5", company.CompanyName || "");
//     s("G5", "Month");
//     s("H5", monthYear);

//     // ── ROW 6: GSTIN / Financial Year ────────────────────────────────────────
//     s("A6", "GSTIN");
//     s("B6", company.GSTNo || "");

//     // ── ROW 8: Section 3.1 heading ───────────────────────────────────────────
//     s("A8", "3.1");
//     s("B8", "Detail of Outward Supplies and Inward supplies liable to reverse charges");

//     // ── ROW 11: 3.1 column headers ───────────────────────────────────────────
//     s("B11", "Nature of Supplies");
//     s("C11", "Total Taxable Value");
//     s("D11", "Integrated Tax");
//     s("E11", "Central Tax");
//     s("F11", "State/ UT Tax");
//     s("G11", "CESS");

//     // ── ROW 12: column numbers ───────────────────────────────────────────────
//     s("B12", 1); s("C12", 2); s("D12", 3); s("E12", 4); s("F12", 5); s("G12", 6);

//     // ── ROW 13: 3.1(a) Outward taxable supplies ──────────────────────────────
//     s("B13", "( a) Outward taxable supplies (other than zero rated, nil rated and exempted)");
//     s("C13", n(outA.TaxableAmt));
//     s("D13", n(outA.IGST));
//     s("E13", n(outA.CGST));
//     s("F13", n(outA.SGST));
//     s("G13", n(outA.Cess));

//     // ── ROW 14: 3.1(b) Zero rated ────────────────────────────────────────────
//     s("B14", "( b) Outward taxable supplies (zero rated)");
//     s("C14", n(outB.TaxableAmt));
//     s("D14", n(outB.IGST));
//     s("E14", n(outB.CGST));
//     s("F14", n(outB.SGST));
//     s("G14", n(outB.Cess));

//     // ── ROW 15: 3.1(c) Nil rated / exempted ─────────────────────────────────
//     s("B15", "( c) Other outward supplies, (Nil rated, exempted)");
//     s("C15", n(outC.TaxableAmt));

//     // ── ROW 16: 3.1(d) Inward supplies reverse charge ────────────────────────
//     s("B16", "( d) Inward supplies (liable to reverse charge)");
//     s("C16", n(outD.TaxableAmt));
//     s("D16", n(outD.IGST));
//     s("E16", n(outD.CGST));
//     s("F16", n(outD.SGST));
//     s("G16", n(outD.Cess));

//     // ── ROW 17: 3.1(e) Non-GST ───────────────────────────────────────────────
//     s("B17", "( e) Non GST outward supplies");
//     s("C17", n(outE.TaxableAmt));

//     // ── ROW 20: Section 3.2 heading ──────────────────────────────────────────
//     s("B20", "3.2 Of the supplies shown in 3.1 (a) above, details of inter-State supplies made to  unregistered persons,composition taxable persons and UIN holders");

//     // ── ROW 22: Unregistered Persons sub-heading ─────────────────────────────
//     s("B22", "Supplies made to Unregistered Persons");

//     // ── ROW 23: Unregistered Persons column headers ──────────────────────────
//     s("B23", "Place of Supply(State/UT)");
//     s("C23", "Total Taxable Value");
//     s("D23", "Amount of Integrated Tax");

//     // ── ROW 24+: Unregistered Persons data rows ──────────────────────────────
//     // Data starts at row 24; additional rows go to 25, 26 ...
//     // but fixed sections below (27, 28, etc.) are still written at their exact rows.
//     const urdRows = (s32.unregistered || []);
//     urdRows.forEach((r, i) => {
//         const rowNum = 24 + i;
//         const normalized = normalizeTaxData(r);
//         s(`B${rowNum}`, r.PlaceOfSupply || stateLabel(r));
//         s(`C${rowNum}`, n(normalized.TaxableAmt));
//         s(`D${rowNum}`, n(normalized.IGST));
//     });

//     // ── ROW 27: Composition Taxable Persons sub-heading ──────────────────────
//     s("B27", "Supplies made to Composition Taxable Persons");

//     // ── ROW 28: Composition column headers ───────────────────────────────────
//     s("B28", "Place of Supply(State/UT)");
//     s("C28", "Total Taxable Value");
//     s("D28", "Amount of Integrated Tax");

//     // Composition data rows start at 29 (TransactionType = 'Composite Supplier')
//     const compRows = (s32.composition || []);
//     compRows.forEach((r, i) => {
//         const rowNum = 29 + i;
//         const normalized = normalizeTaxData(r);
//         s(`B${rowNum}`, r.PlaceOfSupply || stateLabel(r));
//         s(`C${rowNum}`, n(normalized.TaxableAmt));
//         s(`D${rowNum}`, n(normalized.IGST));
//     });

//     // ── ROW 30: UIN Holders sub-heading ──────────────────────────────────────
//     s("B30", "Supplies made to UIN holders");

//     // ── ROW 31: UIN Holders column headers ───────────────────────────────────
//     s("B31", "Place of Supply (State/UT)");
//     s("C31", "Total Taxable Value");
//     s("D31", "Amount of Integrated Tax");

//     // UIN data rows start at 32 (TransactionType = 'UIN holders')
//     const uinRows = (s32.uin_holders || []);
//     uinRows.forEach((r, i) => {
//         const rowNum = 32 + i;
//         const normalized = normalizeTaxData(r);
//         s(`B${rowNum}`, r.PlaceOfSupply || stateLabel(r));
//         s(`C${rowNum}`, n(normalized.TaxableAmt));
//         s(`D${rowNum}`, n(normalized.IGST));
//     });

//     // ── ROW 34: Section 4 heading ─────────────────────────────────────────────
//     s("B34", "4. Eligible ITC");

//     // ── ROW 36: Section 4 column headers ─────────────────────────────────────
//     s("B36", "Details");
//     s("C36", "Integrated Tax");
//     s("D36", "Central Tax");
//     s("E36", "State/ UT Tax");
//     s("F36", "Cess");

//     // ── ROW 37: column numbers ────────────────────────────────────────────────
//     s("B37", 1); s("C37", 2); s("D37", 3); s("E37", 4); s("F37", 5);

//     // ── ROW 38: (A) ITC Available ─────────────────────────────────────────────
//     s("B38", "(A) ITC Available (whether in full or part)");

//     // ── ROW 39: (1) Import of goods (from itcPurchaseQueryA1) ───────────────
//     s("B39", "(1) Import of goods");
//     s("C39", displayValue(itcA1Totals.IGST));
//     s("D39", displayValue(itcA1Totals.CGST));
//     s("E39", displayValue(itcA1Totals.SGST));
//     s("F39", displayValue(itcA1Totals.Cess));

//     // ── ROW 40: (2) Import of Services (from itcPurchaseQueryA2) ────────────
//     s("B40", "(2) Import of Services");
//     s("C40", displayValue(itcA2Totals.IGST));
//     s("D40", displayValue(itcA2Totals.CGST));
//     s("E40", displayValue(itcA2Totals.SGST));
//     s("F40", displayValue(itcA2Totals.Cess));

//     // ── ROW 41: (3) Inward supplies RCM ──────────────────────────────────────
//     s("B41", "(3) Inward supplies liable to reverse charge (other than 1 & 2 above)");
//     s("C41", n((itcAvail.reverse_charge || {}).IGST));
//     s("D41", n((itcAvail.reverse_charge || {}).CGST));
//     s("E41", n((itcAvail.reverse_charge || {}).SGST));
//     s("F41", n((itcAvail.reverse_charge || {}).Cess));

//     // ── ROW 42: (4) Inward supplies from ISD (from itcPurchaseQueryA4) ───────
//     s("B42", "(4) Inward supplies from ISD");
//     s("C42", displayValue(itcA4Totals.IGST));
//     s("D42", displayValue(itcA4Totals.CGST));
//     s("E42", displayValue(itcA4Totals.SGST));
//     s("F42", displayValue(itcA4Totals.Cess));

//     // ── ROW 43: (5) All other ITC (from itcPurchaseQueryA5) ──────────────────
//     s("B43", "(5) All other ITC");
//     s("C43", displayValue(itcA5Totals.IGST));
//     s("D43", displayValue(itcA5Totals.CGST));
//     s("E43", displayValue(itcA5Totals.SGST));
//     s("F43", displayValue(itcA5Totals.Cess));

//     // ── ROW 44: (B) ITC Reversed ──────────────────────────────────────────────
//     s("B44", "(B) ITC Reversed");

//     // ── ROW 45: (1) As per rules 42 & 43 ─────────────────────────────────────
//     s("B45", "(1) As per rules 42 & 43 of CGST Rules");
//     s("C45", displayValue((itcRev.rule_42_43 || {}).IGST));
//     s("D45", displayValue((itcRev.rule_42_43 || {}).CGST));
//     s("E45", displayValue((itcRev.rule_42_43 || {}).SGST));
//     s("F45", displayValue((itcRev.rule_42_43 || {}).Cess));

//     // ── ROW 46: (2) Others ────────────────────────────────────────────────────
//     s("B46", "(2) Others");
//     s("C46", displayValue((itcRev.others || {}).IGST));
//     s("D46", displayValue((itcRev.others || {}).CGST));
//     s("E46", displayValue((itcRev.others || {}).SGST));
//     s("F46", displayValue((itcRev.others || {}).Cess));

//     // ── ROW 47: (C) Net ITC Available ────────────────────────────────────────
//     s("B47", "(C) Net ITC Available (A) \u2013 (B)");
//     s("C47", displayValue(netITCIGST));
//     s("D47", displayValue(netITCCGST));
//     s("E47", displayValue(netITCSGST));
//     s("F47", displayValue(netITCCess));

//     // ── ROW 48: (D) Ineligible ITC ───────────────────────────────────────────
//     s("B48", "(D) Ineligible ITC");

//     // ── ROW 49: (1) As per section 17(5) ─────────────────────────────────────
//     s("B49", "(1) As per section 17(5)");
//     s("C49", displayValue((itcInelig.section_17_5 || {}).IGST));
//     s("D49", displayValue((itcInelig.section_17_5 || {}).CGST));
//     s("E49", displayValue((itcInelig.section_17_5 || {}).SGST));
//     s("F49", displayValue((itcInelig.section_17_5 || {}).Cess));

//     // ── ROW 50: (2) Others ────────────────────────────────────────────────────
//     s("B50", "(2) Others");
//     s("C50", displayValue((itcInelig.others || {}).IGST));
//     s("D50", displayValue((itcInelig.others || {}).CGST));
//     s("E50", displayValue((itcInelig.others || {}).SGST));
//     s("F50", displayValue((itcInelig.others || {}).Cess));

//     // ── ROW 51: Section 5 heading ─────────────────────────────────────────────
//     s("B51", "5. Values of exempt, nil-rated and non-GST inward supplies");

//     // ── ROW 53: Section 5 column headers ─────────────────────────────────────
//     s("B53", "Nature of supplies");
//     s("C53", "Inter-State supplies");
//     s("D53", "Intra-State supplies");

//     // ── ROW 54: column numbers ────────────────────────────────────────────────
//     s("B54", 1); s("C54", 2); s("D54", 3);

//     // ── ROW 55: Composition/Exempt/Nil rated supply ───────────────────────────
//     s("B55", "From a supplier under composition scheme, Exempt and Nil rated supply  ");
//     s("C55", displayValue(s5.nil_exempt_inter));
//     s("D55", displayValue(s5.nil_exempt_intra));

//     // ── ROW 56: Non GST supply ────────────────────────────────────────────────
//     s("B56", "Non GST supply  ");
//     s("C56", displayValue(s5.non_gst_inter));
//     s("D56", displayValue(s5.non_gst_intra));

//     // ── ROW 58: Section 6.1 heading ───────────────────────────────────────────
//     s("B58", "6.1 Payment of Tax");

//     // ── ROW 60: 6.1 top-level column headers ─────────────────────────────────
//     s("B60", "Description");
//     s("C60", "Tax Payable");
//     s("D60", "Paid Through ITC");

//     // ── ROW 61: 6.1 sub-column headers ───────────────────────────────────────
//     s("D61", "Integrated Tax");
//     s("E61", "Central Tax");
//     s("F61", "State / UT Tax");
//     s("G61", "Cess");
//     s("H61", "Tax Paid TDS/TCS");
//     s("I61", "Tax/Cess Paid in Cash");
//     s("J61", "Interest");
//     s("K61", "Late Fee");

//     // ── ROW 62: column numbers ────────────────────────────────────────────────
//     s("B62", 1); s("C62", 2); s("D62", 3); s("E62", 4); s("F62", 5);
//     s("G62", 6); s("H62", 7); s("I62", 8); s("J62", 9); s("K62", 10);

//     // ── ROW 63: Integrated Tax payable row ───────────────────────────────────
//     // Tax Payable in C; ITC paid through IGST in D (=0 since IGST pays IGST)
//     s("B63", "Integrated Tax");
//     s("C63", displayValue(outwardIGST));
//     s("D63", displayValue(0));

//     // ── ROW 64: Central Tax payable row ──────────────────────────────────────
//     // ITC used against CGST goes in E64
//     s("B64", "Central Tax");
//     s("C64", displayValue(outwardCGST));
//     s("E64", displayValue(netITCCGST > 0 ? netITCCGST : 0));

//     // ── ROW 65: State/UT Tax payable row ─────────────────────────────────────
//     // ITC used against SGST goes in F65
//     s("B65", "State/UT Tax");
//     s("C65", displayValue(outwardSGST));
//     s("F65", displayValue(netITCSGST > 0 ? netITCSGST : 0));

//     // ── ROW 66: Cess payable row ──────────────────────────────────────────────
//     // ITC used against Cess goes in G66
//     s("B66", "Cess");
//     s("C66", displayValue(outwardCess));
//     s("G66", displayValue(netITCCess > 0 ? netITCCess : 0));

//     // ── ROW 68: Section 6.2 heading ───────────────────────────────────────────
//     s("B68", "6.2 TDS/TCS Credit");

//     // ── ROW 70: 6.2 column headers ────────────────────────────────────────────
//     s("B70", "Details");
//     s("C70", "Integrated Tax");
//     s("D70", "Central Tax");
//     s("E70", "State/ UT Tax");

//     // ── ROW 71: column numbers ────────────────────────────────────────────────
//     s("B71", 1); s("C71", 2); s("D71", 3); s("E71", 4);

//     // ── ROW 72-73: TDS / TCS ─────────────────────────────────────────────────
//     s("B72", "TDS");
//     s("B73", "TCS");

//     // ── ROW 75: Verification ──────────────────────────────────────────────────
//     s("B75", "Verification (by Authorised signatory)");

//     // ── ROW 77-78: Declaration text ───────────────────────────────────────────
//     s("B77", "I hereby solemnly affirm and declare that the information given herein above is true and correct to the best of my knowledge and belief ");
//     s("B78", "and nothing has been concealed there from.");

//     // ── ROW 80-86: Instructions ───────────────────────────────────────────────
//     s("B80", "Instructions:");
//     s("B81", "1) Value of Taxable Supplies = Value of invoices + value of Debit Notes \u2013 value of credit notes + value of advances received for which");
//     s("B82", " invoices have not been issued in the same month \u2013 value of advances adjusted against invoices");
//     s("B84", "2) Details of advances as well as adjustment of same against invoices to be adjusted and not shown separately");
//     s("B86", "3) Amendment in any details to be adjusted and not shown separately.");

//     // ── Additional Data Sections ───────────────────────────────────────────────
//     let currentRow = 90;

//     // Inward Supplies
//     if (inwardSupplies.rows && inwardSupplies.rows.length > 0) {
//         s(`B${currentRow}`, "Inward Supplies Details");
//         currentRow++;
//         const inwardRows = inwardSupplies.rows;
//         inwardRows.forEach((r) => {
//             const normalized = normalizeTaxData(r);
//             s(`B${currentRow}`, r.Description || "");
//             s(`C${currentRow}`, n(normalized.TaxableAmt));
//             s(`D${currentRow}`, n(normalized.IGST));
//             s(`E${currentRow}`, n(normalized.CGST));
//             s(`F${currentRow}`, n(normalized.SGST));
//             currentRow++;
//         });
//         currentRow += 1;
//     }

//     // Zero Rated Invoice Details
//     if (zeroRatedDetails && zeroRatedDetails.length > 0) {
//         s(`B${currentRow}`, "Zero Rated - Invoice Details");
//         currentRow++;
//         s(`B${currentRow}`, "Bill Number");
//         s(`C${currentRow}`, "Bill Date");
//         s(`D${currentRow}`, "Bill Amount");
//         s(`E${currentRow}`, "Taxable Amt");
//         s(`F${currentRow}`, "IGST");
//         s(`G${currentRow}`, "CGST");
//         s(`H${currentRow}`, "SGST");
//         s(`I${currentRow}`, "Cess");
//         currentRow++;
//         zeroRatedDetails.forEach((r) => {
//             const normalized = normalizeTaxData(r);
//             s(`B${currentRow}`, r.BillNumber || "");
//             s(`C${currentRow}`, r.BillDate ? new Date(r.BillDate).toLocaleDateString('en-IN') : "");
//             s(`D${currentRow}`, n(r.BillAmt || 0));
//             s(`E${currentRow}`, n(normalized.TaxableAmt));
//             s(`F${currentRow}`, n(normalized.IGST));
//             s(`G${currentRow}`, n(normalized.CGST));
//             s(`H${currentRow}`, n(normalized.SGST));
//             s(`I${currentRow}`, n(normalized.Cess));
//             currentRow++;
//         });
//         currentRow += 1;
//     }

//     // ITC Purchase A1
//     if (itcA1.rows && itcA1.rows.length > 0) {
//         s(`B${currentRow}`, "ITC Purchase Details A1");
//         currentRow++;
//         const itcA1Rows = itcA1.rows;
//         itcA1Rows.forEach((r) => {
//             const normalized = normalizeTaxData(r);
//             s(`B${currentRow}`, r.Description || "");
//             s(`C${currentRow}`, n(normalized.TaxableAmt));
//             s(`D${currentRow}`, n(normalized.IGST));
//             s(`E${currentRow}`, n(normalized.CGST));
//             s(`F${currentRow}`, n(normalized.SGST));
//             currentRow++;
//         });
//         currentRow += 1;
//     }

//     // ITC Purchase A2
//     if (itcA2.rows && itcA2.rows.length > 0) {
//         s(`B${currentRow}`, "ITC Purchase Details A2");
//         currentRow++;
//         const itcA2Rows = itcA2.rows;
//         itcA2Rows.forEach((r) => {
//             const normalized = normalizeTaxData(r);
//             s(`B${currentRow}`, r.Description || "");
//             s(`C${currentRow}`, n(normalized.TaxableAmt));
//             s(`D${currentRow}`, n(normalized.IGST));
//             s(`E${currentRow}`, n(normalized.CGST));
//             s(`F${currentRow}`, n(normalized.SGST));
//             currentRow++;
//         });
//         currentRow += 1;
//     }

//     // ITC Purchase A4
//     if (itcA4.rows && itcA4.rows.length > 0) {
//         s(`B${currentRow}`, "ITC Purchase Details A4");
//         currentRow++;
//         const itcA4Rows = itcA4.rows;
//         itcA4Rows.forEach((r) => {
//             const normalized = normalizeTaxData(r);
//             s(`B${currentRow}`, r.Description || "");
//             s(`C${currentRow}`, n(normalized.TaxableAmt));
//             s(`D${currentRow}`, n(normalized.IGST));
//             s(`E${currentRow}`, n(normalized.CGST));
//             s(`F${currentRow}`, n(normalized.SGST));
//             currentRow++;
//         });
//         currentRow += 1;
//     }

//     // ITC Purchase A5
//     if (itcA5.rows && itcA5.rows.length > 0) {
//         s(`B${currentRow}`, "ITC Purchase Details A5");
//         currentRow++;
//         const itcA5Rows = itcA5.rows;
//         itcA5Rows.forEach((r) => {
//             const normalized = normalizeTaxData(r);
//             s(`B${currentRow}`, r.Description || "");
//             s(`C${currentRow}`, n(normalized.TaxableAmt));
//             s(`D${currentRow}`, n(normalized.IGST));
//             s(`E${currentRow}`, n(normalized.CGST));
//             s(`F${currentRow}`, n(normalized.SGST));
//             currentRow++;
//         });
//         currentRow += 1;
//     }
// };

// // ── Main Component ────────────────────────────────────────────────────────────
// export default function GSTReports({ connectionString, pdfString, initialReportType, openFilterTrigger }) {
//     const { selectedCompany } = useAuth();

//     const [reportType, setReportType] = useState(initialReportType || "gstr1");
//     const [fromDate, setFromDate]     = useState(() => getCurrentMonthDates().fromDate);
//     const [toDate, setToDate]         = useState(() => getCurrentMonthDates().toDate);
//     const [dataLoaded, setDataLoaded] = useState(false);
//     const [loading, setLoading]       = useState(false);
//     const [gstrData, setGstrData]     = useState(null);
//     const [snackbar, setSnackbar]     = useState({ open: false, message: "", severity: "success" });
//     const [validationErrors, setValidationErrors] = useState([]);
//     const [showErrorDownload, setShowErrorDownload] = useState(false);
//     const [showWarningDialog, setShowWarningDialog] = useState(false);

//     useEffect(() => {
//         if (initialReportType) {
//             setReportType(initialReportType);
//             setDataLoaded(false);
//             setGstrData(null);
//         }
//     }, [initialReportType]);

//     useEffect(() => {
//         if (openFilterTrigger > 0) {
//             setDataLoaded(false);
//             setGstrData(null);
//         }
//     }, [openFilterTrigger]);

//     const validateGSTData = async (data) => {
//         const errors = [];
//         const companyGSTIN = selectedCompany?.GSTIN || selectedCompany?.GSTNo || '';
//         const companyState = selectedCompany?.State || '';
//         const companyStateCode = selectedCompany?.StateCode || '';

//         if (reportType === 'gstr1') {
//             if (!companyGSTIN) {
//                 errors.push({ type: 'company', gstNumber: 'N/A', hsnNumber: '', value: 'N/A', message: 'Company GSTIN is not set', severity: 'error' });
//                 return errors;
//             }

//             if (!companyState || !companyStateCode) {
//                 errors.push({ type: 'company', gstNumber: companyGSTIN, hsnNumber: '', value: `State: ${companyState || 'N/A'}, Code: ${companyStateCode || 'N/A'}`, message: 'Company State and State Code are required', severity: 'error' });
//                 return errors;
//             }
//         }

//         // Check Place of Supply in all sheets
//         if (reportType === 'gstr1') {
//             const sheetsToCheck = ['b2b', 'b2cl', 'b2cs', 'cdnr', 'cdnur', 'exp', 'hsn_b2b', 'hsn_b2c'];
//             for (const sheet of sheetsToCheck) {
//                 const rows = data[sheet] || [];
//                 if (Array.isArray(rows)) {
//                     for (let i = 0; i < rows.length; i++) {
//                         const row = rows[i];
//                         if (!row.PlaceofSupply || row.PlaceofSupply.toString().trim() === '') {
//                             errors.push({
//                                 type: 'place_of_supply',
//                                 gstNumber: companyGSTIN,
//                                 hsnNumber: row.HSNNO || '',
//                                 value: `${sheet} row ${i + 1}`,
//                                 message: `Missing Place of Supply in ${sheet} sheet at row ${i + 1}`,
//                                 severity: 'error'
//                             });
//                         }
//                     }
//                 }
//             }
//         }

//         if (reportType === 'gstr1') {
//             try {
//                 const gstValidation = await axios.get(`${connectionString}/api/gst-lookup`, {
//                     params: { gstin: companyGSTIN },
//                     timeout: 10000,
//                 });
//                 if (!gstValidation.data?.success || gstValidation.data?.data?.status !== 'Active') {
//                     errors.push({ type: 'gst', gstNumber: companyGSTIN, hsnNumber: '', value: companyGSTIN, message: 'Company GST is not active or cancelled', severity: 'error' });
//                 }
//             } catch (err) {
//                 errors.push({ type: 'gst', gstNumber: companyGSTIN, hsnNumber: '', value: companyGSTIN, message: 'Failed to validate GST: ' + (err.message || 'Unknown error'), severity: 'warning' });
//             }
//         }

//         if (reportType === 'gstr1' && data?.hsn_b2b) {
//             const hsnCodes = data.hsn_b2b.map(r => r.HSNNO).filter(Boolean);
//             if (hsnCodes.length > 0) {
//                 try {
//                     const uniqueHSN = [...new Set(hsnCodes)];
//                     for (const hsnCode of uniqueHSN) {
//                         const hsnValidation = await axios.get('http://103.133.215.205:82/api/api/hsn', {
//                             params: { code: hsnCode },
//                             timeout: 10000,
//                         });
//                         if (!hsnValidation.data?.success || !hsnValidation.data?.data?.length) {
//                             errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: hsnCode, value: hsnCode, message: `HSN ${hsnCode} not found or invalid (B2B)`, severity: 'error' });
//                         }
//                     }
//                 } catch (err) {
//                     errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: '', value: 'Multiple', message: 'Failed to validate HSN (B2B): ' + (err.message || 'Unknown error'), severity: 'warning' });
//                 }
//             }
//         }

//         if (reportType === 'gstr1' && data?.hsn_b2c) {
//             const hsnCodes = data.hsn_b2c.map(r => r.HSNNO).filter(Boolean);
//             if (hsnCodes.length > 0) {
//                 try {
//                     const uniqueHSN = [...new Set(hsnCodes)];
//                     for (const hsnCode of uniqueHSN) {
//                         const hsnValidation = await axios.get('http://103.133.215.205:82/api/api/hsn', {
//                             params: { code: hsnCode },
//                             timeout: 10000,
//                         });
//                         if (!hsnValidation.data?.success || !hsnValidation.data?.data?.length) {
//                             errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: hsnCode, value: hsnCode, message: `HSN ${hsnCode} not found or invalid (B2C)`, severity: 'error' });
//                         }
//                     }
//                 } catch (err) {
//                     errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: '', value: 'Multiple', message: 'Failed to validate HSN (B2C): ' + (err.message || 'Unknown error'), severity: 'warning' });
//                 }
//             }
//         }

//         return errors;
//     };

//     const generateErrorExcel = async () => {
//         try {
//             const wb = new ExcelJS.Workbook();
//             const ws = wb.addWorksheet('Validation Errors');
//             ws.columns = [
//                 { header: 'Error Type', key: 'type', width: 15 },
//                 { header: 'GST Number', key: 'gstNumber', width: 18 },
//                 { header: 'HSN Number', key: 'hsnNumber', width: 15 },
//                 { header: 'Severity', key: 'severity', width: 10 },
//                 { header: 'Details', key: 'message', width: 50 },
//             ];
//             ws.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
//             ws.getRow(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF953735' } };

//             validationErrors.forEach(err => {
//                 ws.addRow({
//                     type: err.type || 'Unknown',
//                     gstNumber: err.gstNumber || 'N/A',
//                     hsnNumber: err.hsnNumber || '',
//                     severity: err.severity || 'warning',
//                     message: err.message,
//                 });
//             });

//             const buffer = await wb.xlsx.writeBuffer();
//             const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//             const url = URL.createObjectURL(blob);
//             const anchor = document.createElement("a");
//             anchor.href = url;
//             anchor.download = `ValidationErrors_${fromDate}_to_${toDate}.xlsx`;
//             document.body.appendChild(anchor);
//             anchor.click();
//             document.body.removeChild(anchor);
//             URL.revokeObjectURL(url);

//             setSnackbar({ open: true, message: "Error report downloaded.", severity: "info" });
//             setShowErrorDownload(false);
//         } catch (err) {
//             setSnackbar({ open: true, message: "Failed to generate error report: " + err.message, severity: "error" });
//         }
//     };

//     const handleGetData = async () => {
//         const compId = selectedCompany?.CompId;
//         if (!compId) {
//             setSnackbar({ open: true, message: "No company selected.", severity: "error" });
//             return;
//         }

//         try {
//             setLoading(true);
//             setValidationErrors([]);
//             setShowErrorDownload(false);
//             let apiEndpoint = "";

//             if (reportType === "gstr1") {
//                 apiEndpoint = `${connectionString}/api/gst/gstr1-data`;
//             } else if (reportType === "gstr2b") {
//                 apiEndpoint = `${connectionString}/api/gst/gstr2b-data`;
//             } else if (reportType === "gstr3b") {
//                 apiEndpoint = `${connectionString}/api/gst/gstr3b-data`;
//             }

//             const res = await axios.get(apiEndpoint, {
//                 params: { compId, fromDate, toDate },
//             });
//             if (res.data?.success) {
//                 setGstrData(res.data.data);
//                 setDataLoaded(true);

//                 const errors = await validateGSTData(res.data.data);

//                 if (errors.length > 0) {
//                     setValidationErrors(errors);
//                     setShowErrorDownload(true);
//                     setSnackbar({ open: true, message: `${errors.length} validation issue(s) found. Download error report or click Export Excel to proceed.`, severity: "warning" });
//                 } else {
//                     setValidationErrors([]);
//                     setShowErrorDownload(false);
//                     setSnackbar({ open: true, message: "Data loaded. Click Export Excel to download.", severity: "success" });
//                 }
//             } else {
//                 setSnackbar({ open: true, message: "Failed to fetch data.", severity: "error" });
//             }
//         } catch (err) {
//             setSnackbar({ open: true, message: err.response?.data?.error || "Error fetching data.", severity: "error" });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const doExportExcel = async () => {
//         if (!gstrData) return;

//         try {
//             const wb = new ExcelJS.Workbook();
//             wb.creator  = "ReonBook";
//             wb.modified = new Date();
//             let fileName = "";

//             if (reportType === "gstr1") {
//                 addSheet(wb, "b2b",      SUMMARY_TEXTS.b2b,    SHEET_HEADERS.b2b,   mapB2B(gstrData.b2b));
//                 addSheet(wb, "b2cl",     SUMMARY_TEXTS.b2cl,   SHEET_HEADERS.b2cl,  mapB2CL(gstrData.b2cl));
//                 addSheet(wb, "b2cs",     SUMMARY_TEXTS.b2cs,   SHEET_HEADERS.b2cs,  mapB2CS(gstrData.b2cs));
//                 addSheet(wb, "cdnr",     SUMMARY_TEXTS.cdnr,   SHEET_HEADERS.cdnr,  mapCDNR(gstrData.cdnr));
//                 addSheet(wb, "cdnur",    SUMMARY_TEXTS.cdnur,  SHEET_HEADERS.cdnur, mapCDNUR(gstrData.cdnur));
//                 addSheet(wb, "exp",      SUMMARY_TEXTS.exp,    SHEET_HEADERS.exp,   mapEXP(gstrData.exp));
//                 addSheet(wb, "at",       SUMMARY_TEXTS.at,     SHEET_HEADERS.at,    []);
//                 addSheet(wb, "atadj",    SUMMARY_TEXTS.atadj,  SHEET_HEADERS.atadj, []);
//                 addSheet(wb, "exemp",    SUMMARY_TEXTS.exemp,  SHEET_HEADERS.exemp, mapEXEMP(gstrData.exemp));
//                 addSheet(wb, "hsn(b2b)", SUMMARY_TEXTS.hsnb2b, SHEET_HEADERS.hsn,   mapHSN(gstrData.hsn_b2b));
//                 addSheet(wb, "hsn(b2c)", SUMMARY_TEXTS.hsnb2c, SHEET_HEADERS.hsn,   mapHSN(gstrData.hsn_b2c));
//                 addSheet(wb, "docs",     SUMMARY_TEXTS.docs,   SHEET_HEADERS.docs,  mapDOCS(gstrData.docs));
//                 fileName = `GSTR1_${fromDate}_to_${toDate}.xlsx`;

//             } else if (reportType === "gstr2b") {
//                 addSheet(wb, "b2b",  SUMMARY_TEXTS["b2b-2b"],  SHEET_HEADERS["b2b-2b"],  mapB2BPurchases(gstrData.b2b));
//                 addSheet(wb, "b2c",  SUMMARY_TEXTS["b2c-2b"],  SHEET_HEADERS["b2c-2b"],  mapB2CPurchases(gstrData.b2c));
//                 addSheet(wb, "hsn",  SUMMARY_TEXTS["hsn-2b"],  SHEET_HEADERS["hsn-2b"],  mapHSN(gstrData.hsn));
//                 addSheet(wb, "docs", SUMMARY_TEXTS["docs-2b"], SHEET_HEADERS["docs-2b"], mapDOCS(gstrData.docs));
//                 fileName = `GSTR2B_${fromDate}_to_${toDate}.xlsx`;

//             } else if (reportType === "gstr3b") {
//                 addGSTR3BSheet(wb, gstrData, fromDate, toDate);
//                 fileName = `GSTR3B_${fromDate}_to_${toDate}.xlsx`;
//             }

//             const buffer  = await wb.xlsx.writeBuffer();
//             const blob    = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
//             const url     = URL.createObjectURL(blob);
//             const anchor  = document.createElement("a");
//             anchor.href   = url;
//             anchor.download = fileName;
//             document.body.appendChild(anchor);
//             anchor.click();
//             document.body.removeChild(anchor);
//             URL.revokeObjectURL(url);

//         } catch (err) {
//             console.error("Export error:", err);
//             setSnackbar({ open: true, message: "Export failed: " + err.message, severity: "error" });
//         }
//     };

//     const handleExportExcel = () => {
//         if (!gstrData) return;
//         if (validationErrors.length > 0) {
//             setShowWarningDialog(true);
//         } else {
//             doExportExcel();
//         }
//     };

//     const getReportLabel = () =>
//         GST_REPORT_OPTIONS.find(o => o.value === reportType)?.label || "GST Report";

//     return (
//         <>
//             <Box sx={{ display: "flex", flexDirection: "column", height: "100%", background: PAGE_BG }}>

//                 {/* Page Header */}
//                 <Box sx={{
//                     background: NAVY, px: { xs: 2, sm: 3 }, py: 1.5,
//                     display: "flex", alignItems: "center", justifyContent: "space-between",
//                     flexWrap: "wrap", gap: 1.5, flexShrink: 0,
//                 }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <ReceiptLongOutlinedIcon sx={{ fontSize: 18, color: "rgba(255,255,255,0.7)" }} />
//                         <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>
//                             {getReportLabel()}
//                         </Typography>
//                     </Box>
//                     <Button
//                         onClick={handleExportExcel}
//                         disabled={!dataLoaded && validationErrors.length === 0}
//                         startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
//                         sx={btnHeaderSolid}
//                     >
//                         Export Excel
//                     </Button>
//                 </Box>

//                 {/* Filter Card */}
//                 <Box sx={{ p: { xs: 2, sm: 3 }, flexShrink: 0, display: "flex", justifyContent: "center" }}>
//                     <Box sx={{
//                         background: CARD, border: `1px solid ${BORDER}`, borderRadius: "8px",
//                         p: { xs: 2.5, sm: 4 }, width: "100%", maxWidth: 520,
//                         display: "flex", flexDirection: "column", gap: 2,
//                     }}>
//                         <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".6px" }}>
//                             Report Filters
//                         </Typography>

//                         {/* Report Type */}
//                         <Box>
//                             <Typography sx={{ fontSize: 11, color: T2, mb: "5px", fontWeight: 500 }}>Report Type</Typography>
//                             <Select
//                                 size="small"
//                                 fullWidth
//                                 value={reportType}
//                                 onChange={(e) => { setReportType(e.target.value); setDataLoaded(false); setGstrData(null); }}
//                                 sx={{
//                                     borderRadius: "4px", fontSize: 13,
//                                     "& fieldset": { borderColor: BORDER },
//                                     "&:hover fieldset": { borderColor: STEEL },
//                                     "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
//                                 }}
//                             >
//                                 {GST_REPORT_OPTIONS.map(o => (
//                                     <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
//                                 ))}
//                             </Select>
//                         </Box>

//                         {/* From Date & To Date */}
//                         <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, color: T2, mb: "5px", fontWeight: 500 }}>From Date</Typography>
//                                 <TextField
//                                     type="date"
//                                     size="small"
//                                     fullWidth
//                                     value={fromDate}
//                                     onChange={(e) => { setFromDate(e.target.value); setDataLoaded(false); setGstrData(null); }}
//                                     sx={inputSx}
//                                 />
//                             </Box>
//                             <Box>
//                                 <Typography sx={{ fontSize: 11, color: T2, mb: "5px", fontWeight: 500 }}>To Date</Typography>
//                                 <TextField
//                                     type="date"
//                                     size="small"
//                                     fullWidth
//                                     value={toDate}
//                                     onChange={(e) => { setToDate(e.target.value); setDataLoaded(false); setGstrData(null); }}
//                                     sx={inputSx}
//                                 />
//                             </Box>
//                         </Box>

//                         {/* Get Data Button */}
//                         <Button
//                             onClick={handleGetData}
//                             fullWidth
//                             disabled={loading}
//                             sx={btnPrimary}
//                             startIcon={loading ? <CircularProgress size={14} sx={{ color: WHITE }} /> : null}
//                         >
//                             {loading ? "Loading..." : "Get Data"}
//                         </Button>

//                     </Box>
//                 </Box>

//                 {/* Content Area */}
//                 <Box sx={{ flex: 1, px: { xs: 2, sm: 3 }, pb: 3 }}>
//                     {showErrorDownload && (
//                         <Box sx={{
//                             background: CARD, border: `2px solid #D32F2F`, borderRadius: "8px",
//                             p: 2.5, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 2,
//                         }}>
//                             <Box sx={{ flex: 1 }}>
//                                 <Typography sx={{ fontSize: 13, color: "#D32F2F", fontWeight: 600, mb: 0.5 }}>
//                                     ⚠️ Validation Errors Found
//                                 </Typography>
//                                 <Typography sx={{ fontSize: 12, color: T2 }}>
//                                     {validationErrors.length} error(s) detected. Download error report below.
//                                 </Typography>
//                             </Box>
//                             <Button
//                                 onClick={generateErrorExcel}
//                                 sx={{
//                                     background: "#D32F2F", color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
//                                     textTransform: "none", px: 2, height: 36, whiteSpace: "nowrap",
//                                     "&:hover": { background: "#B71C1C" },
//                                 }}
//                             >
//                                 Download Error Report
//                             </Button>
//                         </Box>
//                     )}
//                     {dataLoaded && (
//                         <Box sx={{
//                             background: CARD, border: `1px solid ${BORDER}`, borderRadius: "8px",
//                             p: 2.5, display: "flex", alignItems: "center", justifyContent: "center", gap: 1,
//                         }}>
//                             <FileDownloadOutlinedIcon sx={{ fontSize: 18, color: STEEL }} />
//                             <Typography sx={{ fontSize: 13, color: T2 }}>
//                                 Data ready — click <strong>Export Excel</strong> in the header to download.
//                             </Typography>
//                         </Box>
//                     )}
//                 </Box>

//             </Box>

//             {/* Download Warning Dialog */}
//             <Dialog open={showWarningDialog} onClose={() => setShowWarningDialog(false)}>
//                 <DialogTitle sx={{ fontWeight: 700, color: T1 }}>
//                     ⚠️ Download Excel File
//                 </DialogTitle>
//                 <DialogContent>
//                     <Typography sx={{ fontSize: 13, color: T2, mt: 1 }}>
//                         Do you really want to download the Excel file?
//                     </Typography>
//                 </DialogContent>
//                 <DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
//                     <Button
//                         onClick={() => setShowWarningDialog(false)}
//                         sx={{ color: T2, textTransform: "none" }}
//                     >
//                         No
//                     </Button>
//                     <Button
//                         onClick={() => {
//                             setShowWarningDialog(false);
//                             doExportExcel();
//                         }}
//                         sx={{
//                             background: STEEL, color: WHITE, borderRadius: "4px", textTransform: "none",
//                             "&:hover": { background: "#1640A0" },
//                         }}
//                     >
//                         Yes
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={3500}
//                 onClose={() => setSnackbar(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert severity={snackbar.severity} onClose={() => setSnackbar(s => ({ ...s, open: false }))} sx={{ fontSize: 13 }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// }









import React, { useState, useEffect } from "react";
import {
    Box, Typography, Button, TextField, MenuItem, Select,
    Snackbar, Alert, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions,
    Table, TableHead, TableBody, TableRow, TableCell, Paper, TableContainer, Chip,
    Autocomplete,
} from "@mui/material";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useAuth } from "../context/AuthContext";
import { getCurrentFYear } from "../utils/financialYear";
import useDataLoadingState from "../hooks/useDataLoadingState";
import LoadingSpinner from "../components/Common/LoadingSpinner";
import axios from "axios";
import ExcelJS from "exceljs";

// Fresh axios instance without auth interceptors, for calling external APIs (avoids CORS issues from headers like x-session-token)
const axiosNoAuth = axios.create();

// ── Design Tokens ─────────────────────────────────────────────────────────────
const NAVY = "#0D2137";
const STEEL = "#1B4FBB";
const STEEL_LT = "#EBF2FF";
const PAGE_BG = "#F4F6F9";
const CARD = "#FFFFFF";
const BORDER = "#E2E8F0";
const TH_BG = "#F7F9FC";
const T1 = "#1A202C";
const T2 = "#4A5568";
const T3 = "#718096";
const WHITE = "#FFFFFF";

// ── Styles ────────────────────────────────────────────────────────────────────
const btnPrimary = {
    background: STEEL, color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
    textTransform: "none", px: 2.5, height: 36, whiteSpace: "nowrap",
    "&:hover": { background: "#1640A0" },
    "&:disabled": { background: BORDER, color: T3 },
};
const btnHeaderSolid = {
    color: NAVY, background: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 700,
    textTransform: "none", px: 1.75, height: 30, whiteSpace: "nowrap",
    "&:hover": { background: "#E8EDF5" },
    "&:disabled": { background: "rgba(255,255,255,0.25)", color: "rgba(13,33,55,0.35)" },
};
const inputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "4px", background: CARD, fontSize: 13,
        "& fieldset": { borderColor: BORDER },
        "&:hover fieldset": { borderColor: STEEL },
        "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
    },
};

// ── Constants ─────────────────────────────────────────────────────────────────
const GST_REPORT_OPTIONS = [
    { value: "gstr1", label: "GSTR-1" },
    { value: "gstr2b", label: "GSTR-2B" },
    { value: "gstr3b", label: "GSTR-3B" },
];

const getFinancialYearDates = () => {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();
    const fyStart = month >= 3 ? year : year - 1;
    const fromDate = `${fyStart}-04-01`;
    const toDate = `${fyStart + 1}-03-31`;
    return { fromDate, toDate };
};

const getCurrentMonthDates = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const fromDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;
    const lastDay = new Date(year, month + 1, 0).getDate();
    const toDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
    return { fromDate, toDate };
};

// ── Excel Helpers ─────────────────────────────────────────────────────────────
const SUMMARY_BG_ARGB = "FF538ED5";
const HEADER_BG_ARGB = "FFF8CBAC";

const fmtDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return String(dateStr);
    return d;
};

const cessVal = (v) => (!v || Number(v) === 0) ? "" : Number(v);

const toProperCase = (str) => (str || "").toString().toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

const stateLabel = (r) => {
    const code = r.StateCode || "";
    const state = toProperCase(r.State || r.state || "");
    return code ? `${code}-${state}` : state;
};

const SUMMARY_TEXTS = {
    b2b: "Summary For B2B(4)",
    b2cl: "Summary For B2CL(5)",
    b2cs: "Summary For B2CS(6)",
    cdnr: "Summary For CDNR(9B)",
    cdnur: "Summary For CDNUR(9B)",
    exp: "Summary For EXP(6)",
    at: "Summary For Advance Received (11B)",
    atadj: "Summary For Advance Adjusted (11B)",
    exemp: "Summary For Nil rated, exempted and non GST outward supplies (8)",
    hsnb2b: "Summary For HSN(12)",
    hsnb2c: "Summary For HSN(12)",
    docs: "Summary of documents issued during the tax period(13)",
    "b2b-2b": "Summary For B2B Purchases(4A)",
    "b2c-2b": "Summary For B2C Purchases(4C)",
    "hsn-2b": "Summary For HSN(14)",
    "docs-2b": "Summary of documents received during the tax period(13B)",
    "outward": "Outward Supplies",
    "inward": "Inward Supplies",
    "taxsummary": "Tax Summary",
};

const SHEET_HEADERS = {
    b2b: [
        "GSTIN/UIN of Recipient", "Receiver Name", "Invoice Number", "Invoice date",
        "Invoice Value", "Place Of Supply", "Reverse Charge",
        "Applicable % of Tax Rate", "Invoice Type", "E-Commerce GSTIN",
        "Rate", "Taxable Value", "Cess Amount",
    ],
    b2cl: [
        "Invoice Number", "Invoice date", "Invoice Value", "Place Of Supply",
        "Applicable % of Tax Rate", "Rate", "Taxable Value", "Cess Amount", "E-Commerce GSTIN",
    ],
    b2cs: [
        "Type", "Place Of Supply", "Applicable % of Tax Rate",
        "Rate", "Taxable Value", "Cess Amount", "E-Commerce GSTIN",
    ],
    cdnr: [
        "GSTIN/UIN of Recipient", "Receiver Name", "Note Number", "Note Date",
        "Note Type", "Place Of Supply", "Reverse Charge", "Note Supply Type",
        "Note Value", "Applicable % of Tax Rate", "Rate", "Taxable Value", "Cess Amount",
    ],
    cdnur: [
        "UR Type", "Note Number", "Note Date", "Note Type", "Place Of Supply",
        "Note Value", "Applicable % of Tax Rate", "Rate", "Taxable Value", "Cess Amount",
    ],
    exp: [
        "Export Type", "Invoice Number", "Invoice date", "Invoice Value",
        "Port Code", "Shipping Bill Number", "Shipping Bill Date",
        "Rate", "Taxable Value", "Cess Amount",
    ],
    at: ["Place Of Supply", "Applicable % of Tax Rate", "Rate", "Gross Advance Received", "Cess Amount"],
    atadj: ["Place Of Supply", "Applicable % of Tax Rate", "Rate", "Gross Advance adjusted", "Cess Amount"],
    exemp: [
        "Description", "Nil Rated Supplies",
        "exempted (other than nil rated/non GST supply )", "Non-GST supplies",
    ],
    hsn: [
        "HSN", "Description", "UQC", "Total Quantity", "Total Value",
        "Rate", "Taxable Value", "Integrated Tax Amount",
        "Central Tax Amount", "State/UT Tax Amount", "Cess Amount",
    ],
    docs: ["Nature of Document", "Sr. No. From", "Sr. No. To", "Total Number", "Cancelled"],
    "b2b-2b": [
        "GSTIN/UIN of Supplier", "Supplier Name", "Invoice Number", "Invoice date",
        "Invoice Value", "Place Of Supply", "Reverse Charge",
        "Applicable % of Tax Rate", "Invoice Type", "E-Commerce GSTIN",
        "Rate", "Taxable Value", "Cess Amount",
    ],
    "b2c-2b": [
        "Type", "Place Of Supply", "Applicable % of Tax Rate",
        "Rate", "Taxable Value", "Cess Amount", "E-Commerce GSTIN",
    ],
    "hsn-2b": [
        "HSN", "Description", "UQC", "Total Quantity", "Total Value",
        "Rate", "Taxable Value", "Integrated Tax Amount",
        "Central Tax Amount", "State/UT Tax Amount", "Cess Amount",
    ],
    "docs-2b": ["Nature of Document", "Sr. No. From", "Sr. No. To", "Total Number", "Cancelled"],
    outward: ["Supply Type", "Taxable Amount", "CGST", "SGST", "IGST", "Cess"],
    inward: ["Supply Type", "Purchase Taxable", "Purchase CGST", "Purchase SGST", "Purchase IGST", "Purchase Cess", "Credit Note Taxable", "Credit Note CGST", "Credit Note SGST", "Credit Note IGST", "Credit Note Cess"],
    taxsummary: ["Category", "CGST", "SGST", "IGST", "Cess"],
};

const addSheet = (wb, sheetName, summaryText, headers, dataRows) => {
    const ws = wb.addWorksheet(sheetName);

    const c1 = ws.getCell("A1");
    c1.value = summaryText;
    c1.fill = { type: "pattern", pattern: "solid", fgColor: { argb: SUMMARY_BG_ARGB } };
    c1.font = { color: { argb: "FFFFFFFF" }, bold: true, size: 11 };
    c1.alignment = { vertical: "middle" };

    const headerRow = ws.getRow(4);
    headers.forEach((h, i) => {
        const cell = headerRow.getCell(i + 1);
        cell.value = h;
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: HEADER_BG_ARGB } };
        cell.font = { bold: true, size: 10 };
        cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    });
    headerRow.height = 32;

    dataRows.forEach((row, idx) => {
        const wsRow = ws.getRow(idx + 5);
        row.forEach((val, col) => {
            const cell = wsRow.getCell(col + 1);
            if (val instanceof Date) {
                cell.value = val;
                cell.numFmt = "DD-MMM-YY";
            } else {
                cell.value = (val === "" || val == null) ? "" : val;
            }
        });
    });

    ws.columns.forEach((col, i) => {
        let maxLen = headers[i] ? headers[i].length : 10;
        dataRows.forEach(row => {
            const v = row[i];
            if (v != null && String(v).length > maxLen) maxLen = String(v).length;
        });
        col.width = Math.min(Math.max(maxLen + 3, 12), 48);
    });
};

// ── Data row mappers ──────────────────────────────────────────────────────────

const mapB2B = (rows) => (rows || []).map(r => [
    r.GSTNo || "",
    r.ReceiverName || "",
    r.InvoiceNumber || "",
    fmtDate(r.InvoiceDate),
    r.InvoiceValue || 0,
    stateLabel(r),
    "",
    "",
    "Regular",
    "",
    r.gstrate || 0,
    r.TaxableAmt || 0,
    cessVal(r.cessamt),
]);

const mapB2CL = (rows) => (rows || []).map(r => [
    r.BillNumber || "",
    fmtDate(r.BillDate),
    r.BillAmt || 0,
    stateLabel(r),
    "",
    r.IGST || 0,
    r.TaxableAmt || 0,
    cessVal(r.CessAmt),
    "",
]);

const mapB2CS = (rows) => (rows || []).map(r => [
    "OE",
    stateLabel(r),
    "",
    r.IGST || r.CGST || 0,
    r.TaxableAmt || 0,
    cessVal(r.CessAmt),
    "",
]);

const mapCDNR = (b2bRows) => (b2bRows || []).map(r => [
    r.GSTNo || "",
    r.ReceiverName || "",
    r.InvoiceNumber || "",
    fmtDate(r.InvoiceDate),
    "C",
    stateLabel(r),
    "",
    "B2B",
    r.InvoiceValue || 0,
    "",
    r.gstrate || 0,
    r.TaxableAmt || 0,
    cessVal(r.cessamt),
]);

const mapCDNUR = (b2clRows) => (b2clRows || []).map(r => [
    "B2CL",
    r.BillNumber || "",
    fmtDate(r.BillDate),
    "C",
    stateLabel(r),
    r.BillAmt || 0,
    "",
    r.IGST || 0,
    r.TaxableAmt || 0,
    cessVal(r.CessAmt),
]);

const mapEXP = (rows) => (rows || []).map(r => [
    r.GSTCategory === "WPAY" ? "WPAY" : "WOPAY",
    r.BillNumber || "",
    fmtDate(r.BillDate),
    r.BillAmt || 0,
    "",
    "",
    "",
    r.IGst > 0 ? r.IGst : ((r.CGst || 0) + (r.SGst || 0)),
    r.TaxableAmt || 0,
    cessVal(r.CessAmt),
]);

const mapEXEMP = (rows) => (rows || []).map(r => [
    r.Description || "",
    r["Nil Rated Supplies"] || 0,
    r["Exempted"] || 0,
    r["Non-GST supplies"] || 0,
]);

const mapHSN = (rows) => (rows || []).map(r => [
    r.HSNNO || "",
    r.HSNDescription || "",
    r.UQC || "",
    r.QTY || 0,
    r.BILLAMT || 0,
    (Number(r.IGSTRate) > 0 ? Number(r.IGSTRate) : (Number(r.CGSTRate || 0) + Number(r.SGSTRate || 0))).toString(),
    r.TAXABLEAMT || 0,
    r.IGSTAMT || 0,
    r.CGSTAMT || 0,
    r.SGSTAMT || 0,
    cessVal(r.CESSAMT),
]);

const mapDOCS = (rows) => (rows || []).map(r => [
    r.NatureofDocument || "",
    r.FromNo || "",
    r.ToNo || "",
    r.TotalCount || 0,
    r.Cancelled || 0,
]);

const mapB2BPurchases = (rows) => (rows || []).map(r => [
    r.GSTNo || "",
    r.SupplierName || "",
    r.InvoiceNumber || "",
    fmtDate(r.InvoiceDate),
    r.InvoiceValue || 0,
    stateLabel(r),
    "",
    "",
    "Regular",
    "",
    r.gstrate || 0,
    r.TaxableAmt || 0,
    cessVal(r.cessamt),
]);

const mapB2CPurchases = (rows) => (rows || []).map(r => [
    "OE",
    stateLabel(r),
    "",
    r.IGST || r.CGST || 0,
    r.TaxableAmt || 0,
    cessVal(r.CessAmt),
    "",
]);

const mapOutwardSupplies = (rows) => (rows || []).map(r => [
    r.SupplyType || "",
    r.TaxableAmt || 0,
    r.CGST || 0,
    r.SGST || 0,
    r.IGST || 0,
    cessVal(r.Cess),
]);

const mapInwardSupplies = (rows) => (rows || []).map(r => [
    r.SupplyType || "",
    r.PurchaseTaxableAmt || 0,
    r.PurchaseCGST || 0,
    r.PurchaseSGST || 0,
    r.PurchaseIGST || 0,
    cessVal(r.PurchaseCess),
    r.CreditNoteTaxableAmt || 0,
    r.CreditNoteCGST || 0,
    r.CreditNoteSGST || 0,
    r.CreditNoteIGST || 0,
    cessVal(r.CreditNoteCess),
]);

const mapTaxSummary = (rows) => (rows || []).map(r => [
    r.Category || "",
    r.CGST || 0,
    r.SGST || 0,
    r.IGST || 0,
    cessVal(r.Cess),
]);

// ── GSTR-3B Setoff View — derives the "GST SETOFF" summary grid (Op. Bal /
// Inward Supply / Total Input Credit / Op. Bal / Outward Supply / Total Output
// Liability / Cl. Bal, plus the IGST/CGST/SGST/CESS cross-setoff matrix and
// Liability to be Paid / Credit Receivable) purely from gstrData — read-only,
// additive UI helper. Does not touch addGSTR3BSheet/doExportExcel in any way.
const computeGSTR3BSetoff = (data) => {
    const n = (v) => Number(v) || 0;

    const normalizeTaxData = (obj) => {
        if (!obj) return { TaxableAmt: 0, IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
        const getSafeValue = (value) => (value !== null && value !== undefined ? value : 0);
        return {
            TaxableAmt: getSafeValue(obj.TaxableAmt),
            IGST: getSafeValue(obj.IGST || obj.IGSTAMT || obj.IgstAmt || obj.IGSTAmt),
            CGST: getSafeValue(obj.CGST || obj.CGSTAMT || obj.CgstAmt || obj.CGSTAmt),
            SGST: getSafeValue(obj.SGST || obj.SGSTAMT || obj.SgstAmt || obj.SGSTAmt),
            Cess: getSafeValue(obj.Cess || obj.CESSAMT || obj.CessAmt || obj.GSTCEssAmt),
        };
    };

    const aggregateTaxesFromRows = (rows) => {
        if (!rows || !Array.isArray(rows) || rows.length === 0) return {};
        const result = { TaxableAmt: 0, IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
        rows.forEach((r) => {
            const normalized = normalizeTaxData(r);
            result.TaxableAmt += n(normalized.TaxableAmt);
            result.IGST += n(normalized.IGST);
            result.CGST += n(normalized.CGST);
            result.SGST += n(normalized.SGST);
            result.Cess += n(normalized.Cess);
        });
        return result;
    };

    const getOutwardTotals = (section) => {
        let total = normalizeTaxData((section?.total) || section || {});
        if ((n(total.IGST) === 0 && n(total.CGST) === 0 && n(total.SGST) === 0) && section?.by_transaction_type?.length > 0) {
            total = aggregateTaxesFromRows(section.by_transaction_type);
        }
        return total;
    };

    const calculateITCTotals = (itcData) => {
        if (!itcData) return { IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
        if (itcData.rows && Array.isArray(itcData.rows)) return aggregateTaxesFromRows(itcData.rows);
        return normalizeTaxData(itcData);
    };

    const sumTaxValues = (...sources) => ({
        IGST: sources.reduce((sum, src) => sum + n(src?.IGST), 0),
        CGST: sources.reduce((sum, src) => sum + n(src?.CGST), 0),
        SGST: sources.reduce((sum, src) => sum + n(src?.SGST), 0),
        Cess: sources.reduce((sum, src) => sum + n(src?.Cess), 0),
    });

    const s31 = data?.section_31 || {};
    const s4 = data?.section_4 || {};
    const itcA1 = data?.itc_purchase_a1 || {};
    const itcA2 = data?.itc_purchase_a2 || {};
    const itcA4 = data?.itc_purchase_a4 || {};
    const itcA5 = data?.itc_purchase_a5 || {};
    const itcAvail = s4.itc_available || {};
    const itcRev = s4.itc_reversed || {};

    const itcA1Totals = calculateITCTotals(itcA1);
    const itcA2Totals = calculateITCTotals(itcA2);
    const itcA4Totals = calculateITCTotals(itcA4);
    const itcA5Totals = calculateITCTotals(itcA5);

    // Total Input Credit (A) — same "Net ITC Available" derivation as the Excel export
    const itcAvailTotal = sumTaxValues(
        itcA1Totals,
        itcA2Totals,
        {
            IGST: (itcAvail.reverse_charge || {}).IGST,
            CGST: (itcAvail.reverse_charge || {}).CGST,
            SGST: (itcAvail.reverse_charge || {}).SGST,
            Cess: (itcAvail.reverse_charge || {}).Cess,
        },
        itcA4Totals,
        itcA5Totals
    );
    const itcRevTotal = sumTaxValues(itcRev.rule_42_43, itcRev.others);

    const inputCredit = {
        IGST: n(itcAvailTotal.IGST - itcRevTotal.IGST),
        CGST: n(itcAvailTotal.CGST - itcRevTotal.CGST),
        SGST: n(itcAvailTotal.SGST - itcRevTotal.SGST),
        Cess: n(itcAvailTotal.Cess - itcRevTotal.Cess),
    };

    // Total Output Liability — outward taxable supplies (section 3.1(a))
    const outA = getOutwardTotals(s31.a_outward_taxable);
    const outputLiability = {
        IGST: n(outA.IGST),
        CGST: n(outA.CGST),
        SGST: n(outA.SGST),
        Cess: n(outA.Cess),
    };

    // ── Cross-setoff matrix — standard GST setoff order:
    //   IGST credit -> IGST liability first, then CGST, then SGST
    //   CGST credit -> CGST liability first, then IGST
    //   SGST credit -> SGST liability first, then IGST
    //   CESS credit -> CESS liability only
    const remainingCredit = { ...inputCredit };
    const remainingLiability = { ...outputLiability };
    const setoff = {
        IGST: { IGST: 0, CGST: 0, SGST: 0, Cess: 0 },
        CGST: { IGST: 0, CGST: 0, SGST: 0, Cess: 0 },
        SGST: { IGST: 0, CGST: 0, SGST: 0, Cess: 0 },
        Cess: { IGST: 0, CGST: 0, SGST: 0, Cess: 0 },
    };

    const applySetoff = (creditHead, liabilityHeads) => {
        for (const liabHead of liabilityHeads) {
            if (remainingCredit[creditHead] <= 0 || remainingLiability[liabHead] <= 0) continue;
            const used = Math.min(remainingCredit[creditHead], remainingLiability[liabHead]);
            setoff[creditHead][liabHead] = used;
            remainingCredit[creditHead] -= used;
            remainingLiability[liabHead] -= used;
        }
    };

    applySetoff("IGST", ["IGST", "CGST", "SGST"]);
    applySetoff("CGST", ["CGST", "IGST"]);
    applySetoff("SGST", ["SGST", "IGST"]);
    applySetoff("Cess", ["Cess"]);

    const liabilityToBePaid = {
        IGST: n(remainingLiability.IGST),
        CGST: n(remainingLiability.CGST),
        SGST: n(remainingLiability.SGST),
        Cess: n(remainingLiability.Cess),
    };
    const creditReceivable = {
        IGST: n(remainingCredit.IGST),
        CGST: n(remainingCredit.CGST),
        SGST: n(remainingCredit.SGST),
        Cess: n(remainingCredit.Cess),
    };

    const totalPayable = liabilityToBePaid.IGST + liabilityToBePaid.CGST + liabilityToBePaid.SGST + liabilityToBePaid.Cess;
    const totalReceivable = creditReceivable.IGST + creditReceivable.CGST + creditReceivable.SGST + creditReceivable.Cess;

    return { inputCredit, outputLiability, setoff, liabilityToBePaid, creditReceivable, totalPayable, totalReceivable };
};

// ── GSTR-3B Single Sheet Creator ──────────────────────────────────────────────
// Matches the reference template exactly:
//   - No colors, no borders, no bold, no special alignment
//   - Plain font size 11, Calibri
//   - Column B width = 137, Column C width = 18.71
//   - All data placed at the exact same row numbers as the reference file
//   - Section 3.2 unregistered data rows start at row 24
//     (if more than 1 data row, subsequent rows push 3.2 sub-sections down
//      but all sections from 3.1 onward stay at their fixed row numbers)
// NOTE: Because the reference has fixed row numbers for every section,
//   the 3.2 unregistered data is written starting row 24, and only row 24
//   is used for the first entry — extra entries overflow below row 24
//   but all other sections (4, 5, 6.1 etc.) remain at their fixed positions.

const addGSTR3BSheet = (wb, data, fromDate, toDate) => {
    const ws = wb.addWorksheet("GSTR-3B");

    // ── Helper: safe number ──────────────────────────────────────────────────
    const n = (v) => Number(v) || 0;

    // ── Helper: normalize tax column names (IGSTAMT → IGST, IgstAmt → IGST, etc) ──
    const normalizeTaxData = (obj) => {
        if (!obj) return {};
        const getSafeValue = (value) => (value !== null && value !== undefined ? value : 0);
        return {
            TaxableAmt: getSafeValue(obj.TaxableAmt),
            IGST: getSafeValue(
                obj.IGST || obj.IGSTAMT || obj.IgstAmt || obj.IGSTAmt
            ),
            CGST: getSafeValue(
                obj.CGST || obj.CGSTAMT || obj.CgstAmt || obj.CGSTAmt
            ),
            SGST: getSafeValue(
                obj.SGST || obj.SGSTAMT || obj.SgstAmt || obj.SGSTAmt
            ),
            Cess: getSafeValue(
                obj.Cess || obj.CESSAMT || obj.CessAmt || obj.GSTCEssAmt
            ),
            UTGST: getSafeValue(
                obj.UTGST || obj.UTGSTAMT || obj.UtgstAmt || obj.UTGSTAmt
            ),
        };
    };

    // plain cell setter — no color, no bold, no border, size 11 Calibri
    const s = (coord, value) => {
        const cell = ws.getCell(coord);
        cell.value = (value === null || value === undefined) ? "" : value;
        cell.font = { name: "Calibri", size: 11 };
    };

    // ── Column widths — exactly as in reference ──────────────────────────────
    ws.getColumn("A").width = 5;
    ws.getColumn("B").width = 137;
    ws.getColumn("C").width = 18.71;
    ws.getColumn("D").width = 18.71;
    ws.getColumn("E").width = 18.71;
    ws.getColumn("F").width = 18.71;
    ws.getColumn("G").width = 18.71;
    ws.getColumn("H").width = 18.71;
    ws.getColumn("I").width = 18.71;
    ws.getColumn("J").width = 18.71;
    ws.getColumn("K").width = 18.71;

    // ── Company info from API response (companymaster) ───────────────────────
    const company = data.company || {};

    // ── Extract data sections ────────────────────────────────────────────────
    const s31 = data.section_31 || {};
    const s32 = data.section_32 || {};
    const s4 = data.section_4 || {};
    const s5 = data.section_5 || {};
    const s61 = data.section_61 || {};
    const zeroRatedDetails = s31.b_zero_rated?.by_transaction_type || [];
    const inwardSupplies = data.inward_supplies || {};
    const itcA1 = data.itc_purchase_a1 || {};
    const itcA2 = data.itc_purchase_a2 || {};
    const itcA4 = data.itc_purchase_a4 || {};
    const itcA5 = data.itc_purchase_a5 || {};

    const itcAvail = s4.itc_available || {};
    const itcRev = s4.itc_reversed || {};
    const itcInelig = s4.ineligible_itc || {};
    const allOtherITC = itcAvail.all_other_itc || {};

    // Helper: aggregate taxes from row data if totals are missing
    const aggregateTaxesFromRows = (rows) => {
        if (!rows || !Array.isArray(rows) || rows.length === 0) return {};
        let result = { TaxableAmt: 0, IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
        rows.forEach(r => {
            const normalized = normalizeTaxData(r);
            result.TaxableAmt += n(normalized.TaxableAmt);
            result.IGST += n(normalized.IGST);
            result.CGST += n(normalized.CGST);
            result.SGST += n(normalized.SGST);
            result.Cess += n(normalized.Cess);
        });
        return result;
    };

    // Helper: calculate ITC totals from purchase query data
    const calculateITCTotals = (itcData) => {
        if (!itcData) return { IGST: 0, CGST: 0, SGST: 0, Cess: 0 };
        // If data has rows, aggregate them
        if (itcData.rows && Array.isArray(itcData.rows)) {
            return aggregateTaxesFromRows(itcData.rows);
        }
        // Otherwise, try to use direct properties (normalized)
        return normalizeTaxData(itcData);
    };

    // Calculate ITC totals from query data
    const itcA1Totals = calculateITCTotals(itcA1);
    const itcA2Totals = calculateITCTotals(itcA2);
    const itcA4Totals = calculateITCTotals(itcA4);
    const itcA5Totals = calculateITCTotals(itcA5);

    // Helper: sum tax values from multiple sources
    const sumTaxValues = (...sources) => ({
        IGST: sources.reduce((sum, src) => sum + n(src?.IGST), 0),
        CGST: sources.reduce((sum, src) => sum + n(src?.CGST), 0),
        SGST: sources.reduce((sum, src) => sum + n(src?.SGST), 0),
        Cess: sources.reduce((sum, src) => sum + n(src?.Cess), 0),
    });

    // (A) ITC Available - sum of all available ITC sources
    const itcAvailTotal = sumTaxValues(
        itcA1Totals,
        itcA2Totals,
        { IGST: (itcAvail.reverse_charge || {}).IGST, CGST: (itcAvail.reverse_charge || {}).CGST, SGST: (itcAvail.reverse_charge || {}).SGST, Cess: (itcAvail.reverse_charge || {}).Cess },
        itcA4Totals,
        itcA5Totals
    );

    // (B) ITC Reversed - sum of all reversed ITC
    const itcRevTotal = sumTaxValues(
        itcRev.rule_42_43,
        itcRev.others
    );

    // (C) Net ITC Available = (A) - (B)
    const netITCIGST = n(itcAvailTotal.IGST - itcRevTotal.IGST);
    const netITCCGST = n(itcAvailTotal.CGST - itcRevTotal.CGST);
    const netITCSGST = n(itcAvailTotal.SGST - itcRevTotal.SGST);
    const netITCCess = n(itcAvailTotal.Cess - itcRevTotal.Cess);

    // Helper: display value only if > 0, otherwise empty string
    const displayValue = (val) => (n(val) > 0 ? n(val) : "");

    // Month/Year display from toDate
    const toDateObj = new Date(toDate);
    const monthYear = toDateObj.toLocaleString("en-IN", { month: "long", year: "numeric" });

    // Financial year string
    const fyStart = new Date(fromDate).getFullYear();
    const fyEnd = new Date(toDate).getFullYear();
    const fyStr = `${fyStart}-${fyEnd}`;

    // Section data - extract totals from structure and normalize column names
    // If totals are missing/zero, calculate from row data
    const getOutwardTotals = (section) => {
        let total = normalizeTaxData((section?.total) || section || {});
        if ((n(total.IGST) === 0 && n(total.CGST) === 0 && n(total.SGST) === 0) && section?.by_transaction_type?.length > 0) {
            total = aggregateTaxesFromRows(section.by_transaction_type);
        }
        return total;
    };

    const outA = getOutwardTotals(s31.a_outward_taxable);
    const outB = getOutwardTotals(s31.b_zero_rated);
    const outC = normalizeTaxData((s31.c_nil_exempt?.total) || (s31.c_nil_exempt) || {});
    const outD = normalizeTaxData(s31.d_reverse_charge || {});
    const outE = normalizeTaxData((s31.e_non_gst?.total) || (s31.e_non_gst) || {});

    // Extract outward tax amounts for section 6.1
    const outwardIGST = n(outA.IGST);
    const outwardCGST = n(outA.CGST);
    const outwardSGST = n(outA.SGST);
    const outwardCess = n(outA.Cess);

    // ── ROW 5: Name / Month ──────────────────────────────────────────────────
    s("A5", "Name");
    s("B5", company.CompanyName || "");
    s("G5", "Month");
    s("H5", monthYear);

    // ── ROW 6: GSTIN / Financial Year ────────────────────────────────────────
    s("A6", "GSTIN");
    s("B6", company.GSTNo || "");

    // ── ROW 8: Section 3.1 heading ───────────────────────────────────────────
    s("A8", "3.1");
    s("B8", "Detail of Outward Supplies and Inward supplies liable to reverse charges");

    // ── ROW 11: 3.1 column headers ───────────────────────────────────────────
    s("B11", "Nature of Supplies");
    s("C11", "Total Taxable Value");
    s("D11", "Integrated Tax");
    s("E11", "Central Tax");
    s("F11", "State/ UT Tax");
    s("G11", "CESS");

    // ── ROW 12: column numbers ───────────────────────────────────────────────
    s("B12", 1); s("C12", 2); s("D12", 3); s("E12", 4); s("F12", 5); s("G12", 6);

    // ── ROW 13: 3.1(a) Outward taxable supplies ──────────────────────────────
    s("B13", "( a) Outward taxable supplies (other than zero rated, nil rated and exempted)");
    s("C13", n(outA.TaxableAmt));
    s("D13", n(outA.IGST));
    s("E13", n(outA.CGST));
    s("F13", n(outA.SGST));
    s("G13", n(outA.Cess));

    // ── ROW 14: 3.1(b) Zero rated ────────────────────────────────────────────
    s("B14", "( b) Outward taxable supplies (zero rated)");
    s("C14", n(outB.TaxableAmt));
    s("D14", n(outB.IGST));
    s("E14", n(outB.CGST));
    s("F14", n(outB.SGST));
    s("G14", n(outB.Cess));

    // ── ROW 15: 3.1(c) Nil rated / exempted ─────────────────────────────────
    s("B15", "( c) Other outward supplies, (Nil rated, exempted)");
    s("C15", n(outC.TaxableAmt));

    // ── ROW 16: 3.1(d) Inward supplies reverse charge ────────────────────────
    s("B16", "( d) Inward supplies (liable to reverse charge)");
    s("C16", n(outD.TaxableAmt));
    s("D16", n(outD.IGST));
    s("E16", n(outD.CGST));
    s("F16", n(outD.SGST));
    s("G16", n(outD.Cess));

    // ── ROW 17: 3.1(e) Non-GST ───────────────────────────────────────────────
    s("B17", "( e) Non GST outward supplies");
    s("C17", n(outE.TaxableAmt));

    // ── ROW 20: Section 3.2 heading ──────────────────────────────────────────
    s("B20", "3.2 Of the supplies shown in 3.1 (a) above, details of inter-State supplies made to  unregistered persons,composition taxable persons and UIN holders");

    // ── ROW 22: Unregistered Persons sub-heading ─────────────────────────────
    s("B22", "Supplies made to Unregistered Persons");

    // ── ROW 23: Unregistered Persons column headers ──────────────────────────
    s("B23", "Place of Supply(State/UT)");
    s("C23", "Total Taxable Value");
    s("D23", "Amount of Integrated Tax");

    // ── ROW 24+: Unregistered Persons data rows ──────────────────────────────
    // Data starts at row 24; additional rows go to 25, 26 ...
    // but fixed sections below (27, 28, etc.) are still written at their exact rows.
    const urdRows = (s32.unregistered || []);
    urdRows.forEach((r, i) => {
        const rowNum = 24 + i;
        const normalized = normalizeTaxData(r);
        s(`B${rowNum}`, r.PlaceOfSupply || stateLabel(r));
        s(`C${rowNum}`, n(normalized.TaxableAmt));
        s(`D${rowNum}`, n(normalized.IGST));
    });

    // ── ROW 27: Composition Taxable Persons sub-heading ──────────────────────
    s("B27", "Supplies made to Composition Taxable Persons");

    // ── ROW 28: Composition column headers ───────────────────────────────────
    s("B28", "Place of Supply(State/UT)");
    s("C28", "Total Taxable Value");
    s("D28", "Amount of Integrated Tax");

    // Composition data rows start at 29 (TransactionType = 'Composite Supplier')
    const compRows = (s32.composition || []);
    compRows.forEach((r, i) => {
        const rowNum = 29 + i;
        const normalized = normalizeTaxData(r);
        s(`B${rowNum}`, r.PlaceOfSupply || stateLabel(r));
        s(`C${rowNum}`, n(normalized.TaxableAmt));
        s(`D${rowNum}`, n(normalized.IGST));
    });

    // ── ROW 30: UIN Holders sub-heading ──────────────────────────────────────
    s("B30", "Supplies made to UIN holders");

    // ── ROW 31: UIN Holders column headers ───────────────────────────────────
    s("B31", "Place of Supply (State/UT)");
    s("C31", "Total Taxable Value");
    s("D31", "Amount of Integrated Tax");

    // UIN data rows start at 32 (TransactionType = 'UIN holders')
    const uinRows = (s32.uin_holders || []);
    uinRows.forEach((r, i) => {
        const rowNum = 32 + i;
        const normalized = normalizeTaxData(r);
        s(`B${rowNum}`, r.PlaceOfSupply || stateLabel(r));
        s(`C${rowNum}`, n(normalized.TaxableAmt));
        s(`D${rowNum}`, n(normalized.IGST));
    });

    // ── ROW 34: Section 4 heading ─────────────────────────────────────────────
    s("B34", "4. Eligible ITC");

    // ── ROW 36: Section 4 column headers ─────────────────────────────────────
    s("B36", "Details");
    s("C36", "Integrated Tax");
    s("D36", "Central Tax");
    s("E36", "State/ UT Tax");
    s("F36", "Cess");

    // ── ROW 37: column numbers ────────────────────────────────────────────────
    s("B37", 1); s("C37", 2); s("D37", 3); s("E37", 4); s("F37", 5);

    // ── ROW 38: (A) ITC Available ─────────────────────────────────────────────
    s("B38", "(A) ITC Available (whether in full or part)");

    // ── ROW 39: (1) Import of goods (from itcPurchaseQueryA1) ───────────────
    s("B39", "(1) Import of goods");
    s("C39", displayValue(itcA1Totals.IGST));
    s("D39", displayValue(itcA1Totals.CGST));
    s("E39", displayValue(itcA1Totals.SGST));
    s("F39", displayValue(itcA1Totals.Cess));

    // ── ROW 40: (2) Import of Services (from itcPurchaseQueryA2) ────────────
    s("B40", "(2) Import of Services");
    s("C40", displayValue(itcA2Totals.IGST));
    s("D40", displayValue(itcA2Totals.CGST));
    s("E40", displayValue(itcA2Totals.SGST));
    s("F40", displayValue(itcA2Totals.Cess));

    // ── ROW 41: (3) Inward supplies RCM ──────────────────────────────────────
    s("B41", "(3) Inward supplies liable to reverse charge (other than 1 & 2 above)");
    s("C41", n((itcAvail.reverse_charge || {}).IGST));
    s("D41", n((itcAvail.reverse_charge || {}).CGST));
    s("E41", n((itcAvail.reverse_charge || {}).SGST));
    s("F41", n((itcAvail.reverse_charge || {}).Cess));

    // ── ROW 42: (4) Inward supplies from ISD (from itcPurchaseQueryA4) ───────
    s("B42", "(4) Inward supplies from ISD");
    s("C42", displayValue(itcA4Totals.IGST));
    s("D42", displayValue(itcA4Totals.CGST));
    s("E42", displayValue(itcA4Totals.SGST));
    s("F42", displayValue(itcA4Totals.Cess));

    // ── ROW 43: (5) All other ITC (from itcPurchaseQueryA5) ──────────────────
    s("B43", "(5) All other ITC");
    s("C43", displayValue(itcA5Totals.IGST));
    s("D43", displayValue(itcA5Totals.CGST));
    s("E43", displayValue(itcA5Totals.SGST));
    s("F43", displayValue(itcA5Totals.Cess));

    // ── ROW 44: (B) ITC Reversed ──────────────────────────────────────────────
    s("B44", "(B) ITC Reversed");

    // ── ROW 45: (1) As per rules 42 & 43 ─────────────────────────────────────
    s("B45", "(1) As per rules 42 & 43 of CGST Rules");
    s("C45", displayValue((itcRev.rule_42_43 || {}).IGST));
    s("D45", displayValue((itcRev.rule_42_43 || {}).CGST));
    s("E45", displayValue((itcRev.rule_42_43 || {}).SGST));
    s("F45", displayValue((itcRev.rule_42_43 || {}).Cess));

    // ── ROW 46: (2) Others ────────────────────────────────────────────────────
    s("B46", "(2) Others");
    s("C46", displayValue((itcRev.others || {}).IGST));
    s("D46", displayValue((itcRev.others || {}).CGST));
    s("E46", displayValue((itcRev.others || {}).SGST));
    s("F46", displayValue((itcRev.others || {}).Cess));

    // ── ROW 47: (C) Net ITC Available ────────────────────────────────────────
    s("B47", "(C) Net ITC Available (A) \u2013 (B)");
    s("C47", displayValue(netITCIGST));
    s("D47", displayValue(netITCCGST));
    s("E47", displayValue(netITCSGST));
    s("F47", displayValue(netITCCess));

    // ── ROW 48: (D) Ineligible ITC ───────────────────────────────────────────
    s("B48", "(D) Ineligible ITC");

    // ── ROW 49: (1) As per section 17(5) ─────────────────────────────────────
    s("B49", "(1) As per section 17(5)");
    s("C49", displayValue((itcInelig.section_17_5 || {}).IGST));
    s("D49", displayValue((itcInelig.section_17_5 || {}).CGST));
    s("E49", displayValue((itcInelig.section_17_5 || {}).SGST));
    s("F49", displayValue((itcInelig.section_17_5 || {}).Cess));

    // ── ROW 50: (2) Others ────────────────────────────────────────────────────
    s("B50", "(2) Others");
    s("C50", displayValue((itcInelig.others || {}).IGST));
    s("D50", displayValue((itcInelig.others || {}).CGST));
    s("E50", displayValue((itcInelig.others || {}).SGST));
    s("F50", displayValue((itcInelig.others || {}).Cess));

    // ── ROW 51: Section 5 heading ─────────────────────────────────────────────
    s("B51", "5. Values of exempt, nil-rated and non-GST inward supplies");

    // ── ROW 53: Section 5 column headers ─────────────────────────────────────
    s("B53", "Nature of supplies");
    s("C53", "Inter-State supplies");
    s("D53", "Intra-State supplies");

    // ── ROW 54: column numbers ────────────────────────────────────────────────
    s("B54", 1); s("C54", 2); s("D54", 3);

    // ── ROW 55: Composition/Exempt/Nil rated supply ───────────────────────────
    s("B55", "From a supplier under composition scheme, Exempt and Nil rated supply  ");
    s("C55", displayValue(s5.nil_exempt_inter));
    s("D55", displayValue(s5.nil_exempt_intra));

    // ── ROW 56: Non GST supply ────────────────────────────────────────────────
    s("B56", "Non GST supply  ");
    s("C56", displayValue(s5.non_gst_inter));
    s("D56", displayValue(s5.non_gst_intra));

    // ── ROW 58: Section 6.1 heading ───────────────────────────────────────────
    s("B58", "6.1 Payment of Tax");

    // ── ROW 60: 6.1 top-level column headers ─────────────────────────────────
    s("B60", "Description");
    s("C60", "Tax Payable");
    s("D60", "Paid Through ITC");

    // ── ROW 61: 6.1 sub-column headers ───────────────────────────────────────
    s("D61", "Integrated Tax");
    s("E61", "Central Tax");
    s("F61", "State / UT Tax");
    s("G61", "Cess");
    s("H61", "Tax Paid TDS/TCS");
    s("I61", "Tax/Cess Paid in Cash");
    s("J61", "Interest");
    s("K61", "Late Fee");

    // ── ROW 62: column numbers ────────────────────────────────────────────────
    s("B62", 1); s("C62", 2); s("D62", 3); s("E62", 4); s("F62", 5);
    s("G62", 6); s("H62", 7); s("I62", 8); s("J62", 9); s("K62", 10);

    // ── Section 6.1 figures — prefer the ledger-based setoff (data.setoff_ledger,
    // the direct port of the legacy VB.NET pGSTJV_NEW logic: opening balances +
    // period movement + the exact case-based cross-setoff cascade), falling back
    // to the older report-section-only outwardX/netITCX values if the backend
    // hasn't been redeployed yet, so this never breaks either way. ─────────────
    const setoffLedger = data.setoff_ledger || null;
    const chart = setoffLedger?.setoffChart || {};
    const payable = setoffLedger?.liabilityToBePaid || {};
    const s61TaxPayable = setoffLedger
        ? setoffLedger.totalOutputLiability
        : { IGST: outwardIGST, CGST: outwardCGST, SGST: outwardSGST, Cess: outwardCess };

    // ── ROW 63: Integrated Tax payable row ───────────────────────────────────
    // Tax Payable in C; ITC paid through IGST/CGST/SGST in D/E/F (IGST credit can
    // also settle CGST/SGST liability per VB's cross-setoff — only relevant on
    // rows 64/65 below, so D63 stays 0, matching "IGST pays IGST" only here).
    s("B63", "Integrated Tax");
    s("C63", displayValue(s61TaxPayable.IGST));
    s("D63", displayValue(setoffLedger ? n(chart.igstToIgst) : 0));
    s("I63", displayValue(n(payable.IGST)));

    // ── ROW 64: Central Tax payable row ──────────────────────────────────────
    // ITC used against CGST goes in E64; IGST credit spilling into CGST (VB's
    // txtGST(5)/igstToCgst) goes in D64 — this cross-utilization column was
    // previously never written at all.
    s("B64", "Central Tax");
    s("C64", displayValue(s61TaxPayable.CGST));
    s("D64", displayValue(setoffLedger ? n(chart.igstToCgst) : 0));
    s("E64", displayValue(setoffLedger ? n(chart.cgstToCgst) : (netITCCGST > 0 ? netITCCGST : 0)));
    s("I64", displayValue(n(payable.CGST)));

    // ── ROW 65: State/UT Tax payable row ─────────────────────────────────────
    // ITC used against SGST goes in F65; IGST credit spilling into SGST (VB's
    // txtGST(9)/igstToSgst) goes in D65.
    s("B65", "State/UT Tax");
    s("C65", displayValue(s61TaxPayable.SGST));
    s("D65", displayValue(setoffLedger ? n(chart.igstToSgst) : 0));
    s("F65", displayValue(setoffLedger ? n(chart.sgstToSgst) : (netITCSGST > 0 ? netITCSGST : 0)));
    s("I65", displayValue(n(payable.SGST)));

    // ── ROW 66: Cess payable row ──────────────────────────────────────────────
    // ITC used against Cess goes in G66
    s("B66", "Cess");
    s("C66", displayValue(s61TaxPayable.Cess));
    s("G66", displayValue(setoffLedger ? n(chart.cessToCess) : (netITCCess > 0 ? netITCCess : 0)));
    s("I66", displayValue(n(payable.Cess)));

    // ── ROW 68: Section 6.2 heading ───────────────────────────────────────────
    s("B68", "6.2 TDS/TCS Credit");

    // ── ROW 70: 6.2 column headers ────────────────────────────────────────────
    s("B70", "Details");
    s("C70", "Integrated Tax");
    s("D70", "Central Tax");
    s("E70", "State/ UT Tax");

    // ── ROW 71: column numbers ────────────────────────────────────────────────
    s("B71", 1); s("C71", 2); s("D71", 3); s("E71", 4);

    // ── ROW 72-73: TDS / TCS ─────────────────────────────────────────────────
    s("B72", "TDS");
    s("B73", "TCS");

    // ── ROW 75: Verification ──────────────────────────────────────────────────
    s("B75", "Verification (by Authorised signatory)");

    // ── ROW 77-78: Declaration text ───────────────────────────────────────────
    s("B77", "I hereby solemnly affirm and declare that the information given herein above is true and correct to the best of my knowledge and belief ");
    s("B78", "and nothing has been concealed there from.");

    // ── ROW 80-86: Instructions ───────────────────────────────────────────────
    s("B80", "Instructions:");
    s("B81", "1) Value of Taxable Supplies = Value of invoices + value of Debit Notes \u2013 value of credit notes + value of advances received for which");
    s("B82", " invoices have not been issued in the same month \u2013 value of advances adjusted against invoices");
    s("B84", "2) Details of advances as well as adjustment of same against invoices to be adjusted and not shown separately");
    s("B86", "3) Amendment in any details to be adjusted and not shown separately.");

    // ── Additional Data Sections ───────────────────────────────────────────────
    let currentRow = 90;

    // Inward Supplies
    if (inwardSupplies.rows && inwardSupplies.rows.length > 0) {
        s(`B${currentRow}`, "Inward Supplies Details");
        currentRow++;
        const inwardRows = inwardSupplies.rows;
        inwardRows.forEach((r) => {
            const normalized = normalizeTaxData(r);
            s(`B${currentRow}`, r.Description || "");
            s(`C${currentRow}`, n(normalized.TaxableAmt));
            s(`D${currentRow}`, n(normalized.IGST));
            s(`E${currentRow}`, n(normalized.CGST));
            s(`F${currentRow}`, n(normalized.SGST));
            currentRow++;
        });
        currentRow += 1;
    }

    // Zero Rated Invoice Details
    if (zeroRatedDetails && zeroRatedDetails.length > 0) {
        s(`B${currentRow}`, "Zero Rated - Invoice Details");
        currentRow++;
        s(`B${currentRow}`, "Bill Number");
        s(`C${currentRow}`, "Bill Date");
        s(`D${currentRow}`, "Bill Amount");
        s(`E${currentRow}`, "Taxable Amt");
        s(`F${currentRow}`, "IGST");
        s(`G${currentRow}`, "CGST");
        s(`H${currentRow}`, "SGST");
        s(`I${currentRow}`, "Cess");
        currentRow++;
        zeroRatedDetails.forEach((r) => {
            const normalized = normalizeTaxData(r);
            s(`B${currentRow}`, r.BillNumber || "");
            s(`C${currentRow}`, r.BillDate ? new Date(r.BillDate).toLocaleDateString('en-IN') : "");
            s(`D${currentRow}`, n(r.BillAmt || 0));
            s(`E${currentRow}`, n(normalized.TaxableAmt));
            s(`F${currentRow}`, n(normalized.IGST));
            s(`G${currentRow}`, n(normalized.CGST));
            s(`H${currentRow}`, n(normalized.SGST));
            s(`I${currentRow}`, n(normalized.Cess));
            currentRow++;
        });
        currentRow += 1;
    }

    // ITC Purchase A1
    if (itcA1.rows && itcA1.rows.length > 0) {
        s(`B${currentRow}`, "ITC Purchase Details A1");
        currentRow++;
        const itcA1Rows = itcA1.rows;
        itcA1Rows.forEach((r) => {
            const normalized = normalizeTaxData(r);
            s(`B${currentRow}`, r.Description || "");
            s(`C${currentRow}`, n(normalized.TaxableAmt));
            s(`D${currentRow}`, n(normalized.IGST));
            s(`E${currentRow}`, n(normalized.CGST));
            s(`F${currentRow}`, n(normalized.SGST));
            currentRow++;
        });
        currentRow += 1;
    }

    // ITC Purchase A2
    if (itcA2.rows && itcA2.rows.length > 0) {
        s(`B${currentRow}`, "ITC Purchase Details A2");
        currentRow++;
        const itcA2Rows = itcA2.rows;
        itcA2Rows.forEach((r) => {
            const normalized = normalizeTaxData(r);
            s(`B${currentRow}`, r.Description || "");
            s(`C${currentRow}`, n(normalized.TaxableAmt));
            s(`D${currentRow}`, n(normalized.IGST));
            s(`E${currentRow}`, n(normalized.CGST));
            s(`F${currentRow}`, n(normalized.SGST));
            currentRow++;
        });
        currentRow += 1;
    }

    // ITC Purchase A4
    if (itcA4.rows && itcA4.rows.length > 0) {
        s(`B${currentRow}`, "ITC Purchase Details A4");
        currentRow++;
        const itcA4Rows = itcA4.rows;
        itcA4Rows.forEach((r) => {
            const normalized = normalizeTaxData(r);
            s(`B${currentRow}`, r.Description || "");
            s(`C${currentRow}`, n(normalized.TaxableAmt));
            s(`D${currentRow}`, n(normalized.IGST));
            s(`E${currentRow}`, n(normalized.CGST));
            s(`F${currentRow}`, n(normalized.SGST));
            currentRow++;
        });
        currentRow += 1;
    }

    // ITC Purchase A5
    if (itcA5.rows && itcA5.rows.length > 0) {
        s(`B${currentRow}`, "ITC Purchase Details A5");
        currentRow++;
        const itcA5Rows = itcA5.rows;
        itcA5Rows.forEach((r) => {
            const normalized = normalizeTaxData(r);
            s(`B${currentRow}`, r.Description || "");
            s(`C${currentRow}`, n(normalized.TaxableAmt));
            s(`D${currentRow}`, n(normalized.IGST));
            s(`E${currentRow}`, n(normalized.CGST));
            s(`F${currentRow}`, n(normalized.SGST));
            currentRow++;
        });
        currentRow += 1;
    }
};

// ── Main Component ────────────────────────────────────────────────────────────
export default function GSTReports({ connectionString, pdfString, initialReportType, openFilterTrigger }) {
    const { selectedCompany, user } = useAuth();

    const [reportType, setReportType] = useState(initialReportType || "gstr1");
    const [fromDate, setFromDate] = useState(() => getCurrentMonthDates().fromDate);
    const [toDate, setToDate] = useState(() => getCurrentMonthDates().toDate);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [gstrData, setGstrData] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [validationErrors, setValidationErrors] = useState([]);
    const [showErrorDownload, setShowErrorDownload] = useState(false);
    const [showWarningDialog, setShowWarningDialog] = useState(false);

    // GSTR-2B specific states
    const [gstr2bImported, setGstr2bImported] = useState(false);
    const [gstr2bImportFile, setGstr2bImportFile] = useState(null);
    const [gstr2bUploading, setGstr2bUploading] = useState(false);
    const [gstr2bComparisonData, setGstr2bComparisonData] = useState(null);
    const [showComparisonTable, setShowComparisonTable] = useState(false);
    const [gstr2bImportCompId, setGstr2bImportCompId] = useState(null);
    const [gstr2bAutoDeleteTimer, setGstr2bAutoDeleteTimer] = useState(null);
    const [gstr2bTimeRemaining, setGstr2bTimeRemaining] = useState(null);
    const [showTimerExtensionPopup, setShowTimerExtensionPopup] = useState(false);
    const [showExtendTimerButton, setShowExtendTimerButton] = useState(false);
    const [gstr2bDeleteTimestamp, setGstr2bDeleteTimestamp] = useState(null);

    // Source Comparison states (REON vs PORTAL)
    const [sourceComparisonData, setSourceComparisonData] = useState(null);
    const [showSourceComparison, setShowSourceComparison] = useState(false);

    // GSTR-3B Settlement fields (GST Payable A/c client-search)
    const [gstPayableAcInput, setGstPayableAcInput] = useState("");
    const [gstPayableAcOptions, setGstPayableAcOptions] = useState([]);
    const [gstPayableAcSelected, setGstPayableAcSelected] = useState(null);
    const [gstPayableAcLoading, setGstPayableAcLoading] = useState(false);
    const [savingSetoffJV, setSavingSetoffJV] = useState(false);
    // Confirm dialog shown when the backend reports an existing GSTR-3B Setoff
    // JV for this company/financial year (409 confirmationRequired response) —
    // holds the last-used args to re-post with confirmOverride:true on Yes.
    const [setoffJvOverrideConfirm, setSetoffJvOverrideConfirm] = useState({ open: false, message: "", args: null });

    useEffect(() => {
        const companyId = selectedCompany?.CompId;
        if (!companyId) return;
        const timer = setTimeout(async () => {
            try {
                setGstPayableAcLoading(true);
                const res = await axios.get(`${connectionString}/api/company-search`, {
                    params: { field: "FirmName", search: gstPayableAcInput.trim(), companyId },
                });
                const data = Array.isArray(res.data?.data) ? res.data.data : [];
                setGstPayableAcOptions(data.map((i) => ({
                    id: i.id || i.ClientId,
                    label: i.FirmName || i.companyName || "",
                })));
            } catch (err) {
                setGstPayableAcOptions([]);
            } finally {
                setGstPayableAcLoading(false);
            }
        }, 400);
        return () => clearTimeout(timer);
    }, [gstPayableAcInput, connectionString, selectedCompany]);

    // Posts the GSTR-3B setoff Journal Voucher — Node/MySQL port of the
    // VB.NET cmdSave_Click handler (validates GST Payable A/c + JV date, then
    // debits each tax head's liability and credits the selected GST Payable
    // A/c via g_ledgermast/bankcashreceiptmaster/jvdts/g_ledgerbook).
    const handleSaveGSTR3BJV = async (liabilityToBePaid, totalPayable, setoffChart, confirmOverride = false) => {
        if (!gstPayableAcSelected) {
            setSnackbar({ open: true, message: "Please select GST Payable A/c", severity: "error" });
            return;
        }
        if (!toDate || isNaN(new Date(toDate).getTime())) {
            setSnackbar({ open: true, message: "Date is not Valid", severity: "error" });
            return;
        }
        setSavingSetoffJV(true);
        try {
            const res = await axios.post(`${connectionString}/api/gst/gstr3b-post-jv`, {
                companyId: selectedCompany?.CompId,
                GCompId: selectedCompany?.GCompId,
                userId: selectedCompany?.UserId,
                fYear: selectedCompany?.FYear,
                branchId: selectedCompany?.BranchId,
                jvDate: toDate,
                fromDate,
                toDate,
                gstPayableAcId: gstPayableAcSelected.id,
                liabilityToBePaid,
                setoffChart,
                totalPayable,
                ...(confirmOverride ? { confirmOverride: true } : {}),
            });
            setSnackbar({ open: true, message: res.data?.message || "GSTR-3B Setoff JV posted successfully", severity: "success" });
        } catch (err) {
            // Backend responds 409 + confirmationRequired:true when a GSTR-3B
            // Setoff JV already exists for this company/financial year — open a
            // confirm dialog instead of showing it as a plain error.
            if (err?.response?.status === 409 && err?.response?.data?.confirmationRequired) {
                setSetoffJvOverrideConfirm({
                    open: true,
                    message: err.response.data.message || "A GSTR-3B Setoff JV has already been posted for this company/financial year. Do you really want to override the existing JV?",
                    args: { liabilityToBePaid, totalPayable, setoffChart },
                });
                return;
            }
            setSnackbar({
                open: true,
                message: err.response?.data?.message || "Failed to post GSTR-3B Setoff JV",
                severity: "error",
            });
        } finally {
            setSavingSetoffJV(false);
        }
    };

    useEffect(() => {
        if (initialReportType) {
            setReportType(initialReportType);
            setDataLoaded(false);
            setGstrData(null);
            setShowErrorDownload(false);
            setValidationErrors([]);
        }
    }, [initialReportType]);

    useEffect(() => {
        if (openFilterTrigger > 0) {
            setDataLoaded(false);
            setGstrData(null);
            setShowErrorDownload(false);
            setValidationErrors([]);
        }
    }, [openFilterTrigger]);

    // ✅ Clear error download state when switching between GSTR tabs
    useEffect(() => {
        setShowErrorDownload(false);
        setValidationErrors([]);
    }, [reportType]);

    // ✅ Auto-delete GSTR-2B imported data after 15 minutes (with extension support)
    useEffect(() => {
        if (!gstr2bImportCompId) {
            setGstr2bDeleteTimestamp(null);
            return;
        }

        const FIFTEEN_MINUTES = 15 * 60 * 1000; // 15 minutes in milliseconds
        const TWO_MINUTES = 2 * 60 * 1000; // 2 minutes in milliseconds
        const COUNTDOWN_INTERVAL = 1000; // Update counter every 1 second

        // Set initial delete timestamp only if not already set
        if (!gstr2bDeleteTimestamp) {
            const deleteTime = Date.now() + FIFTEEN_MINUTES;
            setGstr2bDeleteTimestamp(deleteTime);
            return; // Will re-run when gstr2bDeleteTimestamp is set
        }

        const deleteTime = gstr2bDeleteTimestamp;

        let popupShown = false;
        let isDeleting = false;

        // Countdown timer - update display every second
        const countdownTimer = setInterval(() => {
            const now = Date.now();
            const timeLeft = deleteTime - now;
            const secondsLeft = Math.ceil(timeLeft / 1000);

            setGstr2bTimeRemaining(Math.max(0, secondsLeft));

            // Show extension popup when 2 minutes remain
            if (timeLeft <= TWO_MINUTES && timeLeft > 0 && !popupShown) {
                popupShown = true;
                setShowTimerExtensionPopup(true);
                console.log('[GSTR-2B] Timer at 2 minutes - showing extension popup');
            }

            // Delete when time is up
            if (timeLeft <= 0 && !isDeleting) {
                isDeleting = true;
                clearInterval(countdownTimer);

                (async () => {
                    try {
                        console.log('[GSTR-2B] Auto-deleting imported data for compId:', gstr2bImportCompId);
                        const deleteUrl = `${connectionString}/api/gst/gstr2b-delete?compId=${gstr2bImportCompId}`;

                        const response = await axios.delete(deleteUrl);

                        if (response.data?.success) {
                            console.log('[GSTR-2B] Auto-delete successful:', response.data.message);
                            setSnackbar({
                                open: true,
                                message: `Auto-cleanup: Imported data has been deleted.`,
                                severity: "info",
                            });
                            // Reset the import state
                            setGstr2bImported(false);
                            setGstr2bImportFile(null);
                            setGstr2bImportCompId(null);
                            setGstr2bTimeRemaining(null);
                            setShowTimerExtensionPopup(false);
                            setShowExtendTimerButton(false);
                            setGstr2bDeleteTimestamp(null);
                        } else {
                            console.error('[GSTR-2B] Auto-delete failed:', response.data?.error);
                        }
                    } catch (err) {
                        console.error('[GSTR-2B] Auto-delete error:', err.message);
                        setSnackbar({
                            open: true,
                            message: `Auto-cleanup failed: ${err.message}`,
                            severity: "error",
                        });
                    }
                })();
            }
        }, COUNTDOWN_INTERVAL);

        // Cleanup function - clear timer if component unmounts or state changes
        return () => {
            clearInterval(countdownTimer);
        };
    }, [gstr2bImportCompId, gstr2bDeleteTimestamp, connectionString]);

    const validateGSTData = async (data) => {
        const errors = [];
        const companyGSTIN = selectedCompany?.GSTIN || selectedCompany?.GSTNo || '';
        const companyState = selectedCompany?.State || '';
        const companyStateCode = selectedCompany?.StateCode || '';

        if (reportType === 'gstr1') {
            if (!companyGSTIN) {
                errors.push({ type: 'company', gstNumber: 'N/A', hsnNumber: '', value: 'N/A', message: 'Company GSTIN is not set', severity: 'error' });
                return errors;
            }

            if (!companyState || !companyStateCode) {
                errors.push({ type: 'company', gstNumber: companyGSTIN, hsnNumber: '', value: `State: ${companyState || 'N/A'}, Code: ${companyStateCode || 'N/A'}`, message: 'Company State and State Code are required', severity: 'error' });
                return errors;
            }
        }

        // Check Place of Supply in all sheets
        if (reportType === 'gstr1') {
            const sheetsToCheck = ['b2b', 'b2cl', 'b2cs', 'cdnr', 'cdnur', 'exp'];
            for (const sheet of sheetsToCheck) {
                const rows = data[sheet] || [];
                if (Array.isArray(rows)) {
                    for (let i = 0; i < rows.length; i++) {
                        const row = rows[i];
                        const placeOfSupply = row.PlaceofSupply || row.StateCode || row.State || row.state || '';
                        if (!placeOfSupply || placeOfSupply.toString().trim() === '') {
                            errors.push({
                                type: 'place_of_supply',
                                gstNumber: row.GSTNo || row.GSTIN || companyGSTIN,
                                hsnNumber: row.HSNNO || '',
                                value: `${sheet} row ${i + 1}`,
                                message: `Missing Place of Supply in ${sheet} sheet at row ${i + 1}`,
                                severity: 'error'
                            });
                        }
                    }
                }
            }
        }

        if (reportType === 'gstr1') {
            try {
                const gstValidation = await axios.get(`${connectionString}/api/gst-lookup`, {
                    params: { searchGstin: companyGSTIN },
                    timeout: 10000,
                });
                if (!gstValidation.data?.success || gstValidation.data?.data?.status !== 'Active') {
                    errors.push({ type: 'gst', gstNumber: companyGSTIN, hsnNumber: '', value: companyGSTIN, message: 'Company GST is not active or cancelled', severity: 'error' });
                }
            } catch (err) {
                errors.push({ type: 'gst', gstNumber: companyGSTIN, hsnNumber: '', value: companyGSTIN, message: 'Failed to validate GST: ' + (err.message || 'Unknown error'), severity: 'warning' });
            }
        }

        if (reportType === 'gstr1' && data?.hsn_b2b) {
            const hsnCodes = data.hsn_b2b.map(r => r.HSNNO).filter(Boolean);
            if (hsnCodes.length > 0) {
                try {
                    const uniqueHSN = [...new Set(hsnCodes)];
                    for (const hsnCode of uniqueHSN) {
                        // const hsnValidation = await axiosNoAuth.get('http://103.133.215.205:82/api/api/hsn', {
                        const hsnValidation = await axiosNoAuth.get(`https://services.reonbook.com/api/hsn`, {
                            params: { code: hsnCode },
                            timeout: 10000,
                        });
                        if (!hsnValidation.data?.success || !hsnValidation.data?.data?.length) {
                            errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: hsnCode, value: hsnCode, message: `HSN ${hsnCode} not found or invalid (B2B)`, severity: 'error' });
                        }
                    }
                } catch (err) {
                    errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: '', value: 'Multiple', message: 'Failed to validate HSN (B2B): ' + (err.message || 'Unknown error'), severity: 'warning' });
                }
            }
        }

        if (reportType === 'gstr1' && data?.hsn_b2c) {
            const hsnCodes = data.hsn_b2c.map(r => r.HSNNO).filter(Boolean);
            if (hsnCodes.length > 0) {
                try {
                    const uniqueHSN = [...new Set(hsnCodes)];
                    for (const hsnCode of uniqueHSN) {
                        // const hsnValidation = await axiosNoAuth.get('http://103.133.215.205:82/api/api/hsn', {
                        const hsnValidation = await axiosNoAuth.get(`https://services.reonbook.com/api/hsn`, {
                            params: { code: hsnCode },
                            timeout: 10000,
                        });
                        if (!hsnValidation.data?.success || !hsnValidation.data?.data?.length) {
                            errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: hsnCode, value: hsnCode, message: `HSN ${hsnCode} not found or invalid (B2C)`, severity: 'error' });
                        }
                    }
                } catch (err) {
                    errors.push({ type: 'hsn', gstNumber: companyGSTIN, hsnNumber: '', value: 'Multiple', message: 'Failed to validate HSN (B2C): ' + (err.message || 'Unknown error'), severity: 'warning' });
                }
            }
        }

        return errors;
    };

    const generateErrorExcel = async () => {
        try {
            const wb = new ExcelJS.Workbook();
            const ws = wb.addWorksheet('Validation Errors');
            ws.columns = [
                { header: 'Error Type', key: 'type', width: 15 },
                { header: 'GST Number', key: 'gstNumber', width: 18 },
                { header: 'HSN Number', key: 'hsnNumber', width: 15 },
                { header: 'Severity', key: 'severity', width: 10 },
                { header: 'Details', key: 'message', width: 50 },
            ];
            ws.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
            ws.getRow(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF953735' } };

            validationErrors.forEach(err => {
                ws.addRow({
                    type: err.type || 'Unknown',
                    gstNumber: err.gstNumber || 'N/A',
                    hsnNumber: err.hsnNumber || '',
                    severity: err.severity || 'warning',
                    message: err.message,
                });
            });

            const buffer = await wb.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `ValidationErrors_${fromDate}_to_${toDate}.xlsx`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);

            setSnackbar({ open: true, message: "Error report downloaded.", severity: "info" });
            setShowErrorDownload(false);
        } catch (err) {
            setSnackbar({ open: true, message: "Failed to generate error report: " + err.message, severity: "error" });
        }
    };

    const handleGetData = async () => {
        const compId = selectedCompany?.CompId;
        if (!compId) {
            setSnackbar({ open: true, message: "No company selected.", severity: "error" });
            return;
        }

        try {
            setLoading(true);
            setValidationErrors([]);
            setShowErrorDownload(false);
            let apiEndpoint = "";

            if (reportType === "gstr1") {
                apiEndpoint = `${connectionString}/api/gst/gstr1-data`;
            } else if (reportType === "gstr2b") {
                apiEndpoint = `${connectionString}/api/gst/gstr2b-data`;
            } else if (reportType === "gstr3b") {
                apiEndpoint = `${connectionString}/api/gst/gstr3b-data`;
            }

            const res = await axios.get(apiEndpoint, {
                params: { compId, fromDate, toDate },
            });
            if (res.data?.success) {
                setGstrData(res.data.data);
                setDataLoaded(true);

                const errors = await validateGSTData(res.data.data);

                if (errors.length > 0) {
                    setValidationErrors(errors);
                    setShowErrorDownload(true);
                    setSnackbar({ open: true, message: `${errors.length} validation issue(s) found. Download error report or click Export Excel to proceed.`, severity: "warning" });
                } else {
                    setValidationErrors([]);
                    setShowErrorDownload(false);
                    setSnackbar({ open: true, message: "Data loaded. Click Export Excel to download.", severity: "success" });
                }
            } else {
                setSnackbar({ open: true, message: "Failed to fetch data.", severity: "error" });
            }
        } catch (err) {
            setSnackbar({ open: true, message: err.response?.data?.error || "Error fetching data.", severity: "error" });
        } finally {
            setLoading(false);
        }
    };

    const doExportExcel = async () => {
        if (!gstrData) return;

        try {
            const wb = new ExcelJS.Workbook();
            wb.creator = "ReonBook";
            wb.modified = new Date();
            let fileName = "";

            if (reportType === "gstr1") {
                addSheet(wb, "b2b", SUMMARY_TEXTS.b2b, SHEET_HEADERS.b2b, mapB2B(gstrData.b2b));
                addSheet(wb, "b2cl", SUMMARY_TEXTS.b2cl, SHEET_HEADERS.b2cl, mapB2CL(gstrData.b2cl));
                addSheet(wb, "b2cs", SUMMARY_TEXTS.b2cs, SHEET_HEADERS.b2cs, mapB2CS(gstrData.b2cs));
                addSheet(wb, "cdnr", SUMMARY_TEXTS.cdnr, SHEET_HEADERS.cdnr, mapCDNR(gstrData.cdnr));
                addSheet(wb, "cdnur", SUMMARY_TEXTS.cdnur, SHEET_HEADERS.cdnur, mapCDNUR(gstrData.cdnur));
                addSheet(wb, "exp", SUMMARY_TEXTS.exp, SHEET_HEADERS.exp, mapEXP(gstrData.exp));
                addSheet(wb, "at", SUMMARY_TEXTS.at, SHEET_HEADERS.at, []);
                addSheet(wb, "atadj", SUMMARY_TEXTS.atadj, SHEET_HEADERS.atadj, []);
                addSheet(wb, "exemp", SUMMARY_TEXTS.exemp, SHEET_HEADERS.exemp, mapEXEMP(gstrData.exemp));
                addSheet(wb, "hsn(b2b)", SUMMARY_TEXTS.hsnb2b, SHEET_HEADERS.hsn, mapHSN(gstrData.hsn_b2b));
                addSheet(wb, "hsn(b2c)", SUMMARY_TEXTS.hsnb2c, SHEET_HEADERS.hsn, mapHSN(gstrData.hsn_b2c));
                addSheet(wb, "docs", SUMMARY_TEXTS.docs, SHEET_HEADERS.docs, mapDOCS(gstrData.docs));
                fileName = `GSTR1_${fromDate}_to_${toDate}.xlsx`;

            } else if (reportType === "gstr2b") {
                addSheet(wb, "b2b", SUMMARY_TEXTS["b2b-2b"], SHEET_HEADERS["b2b-2b"], mapB2BPurchases(gstrData.b2b));
                addSheet(wb, "b2c", SUMMARY_TEXTS["b2c-2b"], SHEET_HEADERS["b2c-2b"], mapB2CPurchases(gstrData.b2c));
                addSheet(wb, "hsn", SUMMARY_TEXTS["hsn-2b"], SHEET_HEADERS["hsn-2b"], mapHSN(gstrData.hsn));
                addSheet(wb, "docs", SUMMARY_TEXTS["docs-2b"], SHEET_HEADERS["docs-2b"], mapDOCS(gstrData.docs));
                fileName = `GSTR2B_${fromDate}_to_${toDate}.xlsx`;

            } else if (reportType === "gstr3b") {
                addGSTR3BSheet(wb, gstrData, fromDate, toDate);
                fileName = `GSTR3B_${fromDate}_to_${toDate}.xlsx`;
            }

            const buffer = await wb.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = fileName;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);

        } catch (err) {
            console.error("Export error:", err);
            setSnackbar({ open: true, message: "Export failed: " + err.message, severity: "error" });
        }
    };

    const handleExportExcel = () => {
        if (!gstrData) return;
        if (validationErrors.length > 0) {
            setShowWarningDialog(true);
        } else {
            doExportExcel();
        }
    };

    const getReportLabel = () =>
        GST_REPORT_OPTIONS.find(o => o.value === reportType)?.label || "GST Report";

    // ✅ Handle timer extension - manages locally without separate API
    const handleExtendTimer = (extensionMinutes) => {
        if (!gstr2bImportCompId || !gstr2bDeleteTimestamp) return;

        console.log('[GSTR-2B] Timer extended by', extensionMinutes, 'minutes');
        setSnackbar({
            open: true,
            message: `Timer extended by ${extensionMinutes} minute${extensionMinutes > 1 ? 's' : ''}. Auto-delete will occur after extended time.`,
            severity: "success",
        });
        setShowTimerExtensionPopup(false);
        setShowExtendTimerButton(false);

        // Extend the delete timestamp by adding extension minutes
        const newDeleteTime = gstr2bDeleteTimestamp + (extensionMinutes * 60 * 1000);
        setGstr2bDeleteTimestamp(newDeleteTime);
        console.log('[GSTR-2B] New delete timestamp:', new Date(newDeleteTime).toLocaleTimeString());
    };

    // GSTR-2B Handlers
    const handleGSTR2BFileUpload = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        // Get compId from selectedCompany - must exist
        const compId = selectedCompany?.CompId;

        console.log('DEBUG: selectedCompany =', selectedCompany);
        console.log('DEBUG: compId =', compId);

        if (!compId || compId === null || compId === undefined) {
            setSnackbar({
                open: true,
                message: "No company selected. Please select a company before uploading.",
                severity: "error"
            });
            return;
        }

        try {
            setGstr2bUploading(true);

            // ✅ Validate file before upload
            console.log('DEBUG: File object:', file);
            console.log('DEBUG: File name:', file?.name);
            console.log('DEBUG: File size:', file?.size);
            console.log('DEBUG: File type:', file?.type);

            if (!file || file.size === 0) {
                setSnackbar({
                    open: true,
                    message: "Selected file is empty or invalid. Please choose a valid Excel file.",
                    severity: "error"
                });
                setGstr2bUploading(false);
                return;
            }

            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                setSnackbar({
                    open: true,
                    message: "Please select a valid Excel file (.xlsx or .xls)",
                    severity: "error"
                });
                setGstr2bUploading(false);
                return;
            }

            // ✅ Create FormData and append file
            const formData = new FormData();
            formData.append("file", file, file.name);

            // Send compId as query parameter (more reliable than FormData for file uploads)
            const uploadUrl = `${connectionString}/api/gst/gstr2b-import?compId=${compId}`;

            console.log('DEBUG: Sending file to:', uploadUrl);
            console.log('DEBUG: CompId in URL:', compId);
            console.log('DEBUG: File being sent:', {
                name: file.name,
                size: file.size,
                type: file.type
            });

            // ✅ IMPORTANT: Do NOT set Content-Type header manually!
            // Axios will automatically set it with proper boundary for multipart/form-data
            const res = await axios.post(uploadUrl, formData);

            if (res.data?.success) {
                setGstr2bImportFile(file.name);
                setGstr2bImported(true);
                // Reset timer for fresh countdown
                setGstr2bDeleteTimestamp(null);
                setGstr2bTimeRemaining(null);
                setShowTimerExtensionPopup(false);
                setShowExtendTimerButton(false);
                // Start 3-minute auto-delete timer
                setGstr2bImportCompId(compId);
                const importedCount = res.data.data?.importedCount || 0;
                setSnackbar({
                    open: true,
                    message: `Successfully imported ${importedCount} records from GSTR-2B file. Data will be automatically deleted after 15 minutes.`,
                    severity: "success",
                });
            } else {
                const errorMsg = res.data?.error || "Import failed.";
                console.error('Backend error:', res.data);
                setSnackbar({
                    open: true,
                    message: errorMsg,
                    severity: "error"
                });
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error || err.message || "Error uploading file.";
            console.error('Upload error:', {
                error: errorMessage,
                response: err.response?.data,
                status: err.response?.status
            });
            setSnackbar({
                open: true,
                message: errorMessage,
                severity: "error",
            });
        } finally {
            setGstr2bUploading(false);
            event.target.value = "";
        }
    };

    const handleGSTR2BComparison = async () => {
        const compId = selectedCompany?.CompId;
        if (!compId) {
            setSnackbar({ open: true, message: "No company selected.", severity: "error" });
            return;
        }

        if (!gstr2bImported) {
            setSnackbar({ open: true, message: "Please import GSTR-2B Excel file first.", severity: "warning" });
            return;
        }

        try {
            setLoading(true);
            const res = await axios.get(`${connectionString}/api/gst/gstr2b-comparison`, {
                params: { compId, fromDate, toDate },
            });

            console.log(res);

            if (res.data?.success) {
                setGstr2bComparisonData(res.data.data);
                // Convert comparison data to source format for unified table display
                const sourceData = convertComparisonDataToSourceFormat(res.data.data);
                setSourceComparisonData(sourceData);
                setShowComparisonTable(true);
                setShowSourceComparison(true);
                setDataLoaded(true);
                setSnackbar({
                    open: true,
                    message: `Comparison completed. ${sourceData.length} records found.`,
                    severity: "info",
                });
            } else {
                setSnackbar({ open: true, message: "Failed to fetch comparison data.", severity: "error" });
            }
        } catch (err) {
            setSnackbar({
                open: true,
                message: err.response?.data?.error || "Error fetching comparison data.",
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    // "+ Add to Reon" — shown only for Portal-only ("Not in Reon") rows in the
    // GSTR-2B Reconciliation table. Resolves row.gstNo against clientmaster
    // (same GST -> take existing client; same GST + matching Trade Name among
    // multiple clients -> take that client; otherwise GST-lookup + insert a
    // new client) via POST /client/resolve-or-insert-from-gst-reco.
    const [insertingRecordKey, setInsertingRecordKey] = useState(null);
    // Rows whose purchase invoice has already been created this session — the
    // "+ Add to Reon" button is hidden for these (per "after completing this
    // remove that Add to Reon button").
    const [postedRecordKeys, setPostedRecordKeys] = useState(() => new Set());
    const handleInsertRecordInReon = async (row) => {
        if (!row.gstNo) {
            setSnackbar({ open: true, message: "This record has no GST Number to match against.", severity: "error" });
            return;
        }
        const rowKey = `${row.gstNo}|${row.billNo}`;
        setInsertingRecordKey(rowKey);
        try {
            const res = await axios.post(`${connectionString}/client/resolve-or-insert-from-gst-reco`, {
                companyId: selectedCompany?.CompId,
                gstNo: row.gstNo,
                tradeName: row.tradeName,
                userId: user?.UserId,
                AppRegID: selectedCompany?.AppRegID || null,
                fYear: getCurrentFYear(),
                branchId: selectedCompany?.BranchId,
                invoiceNumber: row.invoiceNumberRaw,
                invoiceDate: row.invoiceDateRaw,
                invoiceType: row.invoiceType,
                invoiceValue: row.invoiceValue,
                taxableValue: row.taxable,
                integratedTax: row.igst,
                centralTax: row.cgst,
                stateUTTax: row.sgst,
            });
            setSnackbar({ open: true, message: res.data?.message || "Purchase invoice created successfully", severity: "success" });
            setPostedRecordKeys(prev => new Set(prev).add(rowKey));
        } catch (err) {
            setSnackbar({
                open: true,
                message: err.response?.data?.message || "Failed to insert/resolve client from GST reconciliation",
                severity: "error",
            });
        } finally {
            setInsertingRecordKey(null);
        }
    };

    const convertComparisonDataToSourceFormat = (data) => {
        const sourceData = [];
        let srNo = 1;
        const fmtD = (d) => d ? new Date(d).toLocaleDateString('en-GB') : null;

        // Matched records — found in both Reon and Portal
        (data.matched || []).forEach(({ portal, reon, validations }) => {
            sourceData.push({
                srNo: srNo++,
                source: "Matched",
                status: validations.length === 0 ? "Yes" : "No",
                reason: validations.join(", ") || "",
                billNo: reon.InvoiceNumber || portal.InvoiceNumber || "",
                billDate: fmtD(reon.InvoiceDate) || fmtD(portal.InvoiceDate),
                tradeName: reon.SupplierName || portal.TradeLegalName || "",
                gstNo: reon.GSTNo || portal.GSTINOfSupplier || "",
                taxable: reon.TaxableValue || portal.TaxableValue || 0,
                igst: reon.IntegratedTax || portal.IntegratedTax || 0,
                cgst: reon.CentralTax || portal.CentralTax || 0,
                sgst: reon.StateUTTax || portal.StateUTTax || 0,
                cess: reon.CessAmt || portal.CessAmt || 0,
            });
        });

        // Only in Portal — "Not in Reon"
        (data.onlyInExcel || []).forEach(row => {
            sourceData.push({
                srNo: srNo++,
                source: "Portal",
                status: "No",
                reason: "Not in Reon",
                billNo: row.InvoiceNumber || "",
                billDate: fmtD(row.InvoiceDate),
                tradeName: row.TradeLegalName || "",
                gstNo: row.GSTINOfSupplier || "",
                taxable: row.TaxableValue || 0,
                igst: row.IntegratedTax || 0,
                cgst: row.CentralTax || 0,
                sgst: row.StateUTTax || 0,
                cess: row.CessAmt || 0,
                // Raw fields (unformatted) needed only for the "+ Add to Reon"
                // purchase-invoice creation call — not used for display.
                invoiceNumberRaw: row.InvoiceNumber || "",
                invoiceDateRaw: row.InvoiceDate || null,
                invoiceType: row.InvoiceType || "",
                invoiceValue: row.InvoiceValue || 0,
            });
        });

        // Only in Reon — "Not in Portal"
        (data.onlyInDatabase || []).forEach(row => {
            sourceData.push({
                srNo: srNo++,
                source: "Reon",
                status: "No",
                reason: "Not in Portal",
                billNo: row.InvoiceNumber || "",
                billDate: fmtD(row.InvoiceDate),
                tradeName: row.SupplierName || "",
                gstNo: row.GSTNo || "",
                taxable: row.TaxableValue || 0,
                igst: row.IntegratedTax || 0,
                cgst: row.CentralTax || 0,
                sgst: row.StateUTTax || 0,
                cess: row.CessAmt || 0,
            });
        });

        // ✅ Sort by date
        sourceData.sort((a, b) => {
            const dateA = a.billDate || "";
            const dateB = b.billDate || "";
            return dateA.localeCompare(dateB);
        });

        // ✅ Re-assign srNo after sorting so serial numbers stay in order
        sourceData.forEach((row, idx) => {
            row.srNo = idx + 1;
        });

        return sourceData;
    };

    const exportGSTR2BComparison = async () => {
        if (!gstr2bComparisonData) return;

        try {
            const wb = new ExcelJS.Workbook();
            const comparison = gstr2bComparisonData;

            // Sheet 1: Imported Data
            if (comparison.imported && comparison.imported.length > 0) {
                const ws1 = wb.addWorksheet("Imported from GSTR-2B");
                ws1.columns = [
                    { header: "GSTIN of Supplier", key: "GSTINOfSupplier", width: 15 },
                    { header: "Supplier Name", key: "TradeLegalName", width: 25 },
                    { header: "Invoice Number", key: "InvoiceNumber", width: 15 },
                    { header: "Invoice Date", key: "InvoiceDate", width: 12 },
                    { header: "Invoice Value", key: "InvoiceValue", width: 15 },
                    { header: "Taxable Value", key: "TaxableValue", width: 15 },
                    { header: "IGST", key: "IntegratedTax", width: 12 },
                    { header: "CGST", key: "CentralTax", width: 12 },
                    { header: "SGST", key: "StateUTTax", width: 12 },
                    { header: "Cess", key: "CessAmt", width: 12 },
                ];
                ws1.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
                ws1.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF4472C4" } };
                comparison.imported.forEach(row => ws1.addRow(row));
            }

            // Sheet 2: Database Data
            if (comparison.fromDatabase && comparison.fromDatabase.length > 0) {
                const ws2 = wb.addWorksheet("From Database");
                ws2.columns = [
                    { header: "GSTIN of Supplier", key: "GSTNo", width: 15 },
                    { header: "Supplier Name", key: "SupplierName", width: 25 },
                    { header: "Invoice Number", key: "InvoiceNumber", width: 15 },
                    { header: "Invoice Date", key: "InvoiceDate", width: 12 },
                    { header: "Invoice Value", key: "InvoiceValue", width: 15 },
                    { header: "Taxable Value", key: "TaxableAmt", width: 15 },
                    { header: "IGST", key: "IGST", width: 12 },
                    { header: "CGST", key: "CGST", width: 12 },
                    { header: "SGST", key: "SGST", width: 12 },
                    { header: "Cess", key: "CessAmt", width: 12 },
                ];
                ws2.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
                ws2.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF70AD47" } };
                comparison.fromDatabase.forEach(row => ws2.addRow(row));
            }

            // Sheet 3: Only in Excel
            if (comparison.onlyInExcel && comparison.onlyInExcel.length > 0) {
                const ws3 = wb.addWorksheet("Only in Excel");
                ws3.columns = [
                    { header: "GSTIN of Supplier", key: "GSTINOfSupplier", width: 15 },
                    { header: "Supplier Name", key: "TradeLegalName", width: 25 },
                    { header: "Invoice Number", key: "InvoiceNumber", width: 15 },
                    { header: "Invoice Date", key: "InvoiceDate", width: 12 },
                ];
                ws3.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
                ws3.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFF6B6B" } };
                comparison.onlyInExcel.forEach(row => ws3.addRow(row));
            }

            // Sheet 4: Only in Database
            if (comparison.onlyInDatabase && comparison.onlyInDatabase.length > 0) {
                const ws4 = wb.addWorksheet("Only in Database");
                ws4.columns = [
                    { header: "GSTIN of Supplier", key: "GSTNo", width: 15 },
                    { header: "Supplier Name", key: "SupplierName", width: 25 },
                    { header: "Invoice Number", key: "InvoiceNumber", width: 15 },
                    { header: "Invoice Date", key: "InvoiceDate", width: 12 },
                ];
                ws4.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
                ws4.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFB300" } };
                comparison.onlyInDatabase.forEach(row => ws4.addRow(row));
            }

            // Sheet 5: Summary
            const wsSummary = wb.addWorksheet("Summary");
            wsSummary.getCell("A1").value = "GSTR-2B Comparison Summary";
            wsSummary.getCell("A1").font = { bold: true, size: 14 };
            wsSummary.getCell("A3").value = "Metric";
            wsSummary.getCell("B3").value = "Count";
            wsSummary.getRow(3).font = { bold: true };
            wsSummary.getCell("A4").value = "Imported from Excel";
            wsSummary.getCell("B4").value = comparison.imported?.length || 0;
            wsSummary.getCell("A5").value = "From Database";
            wsSummary.getCell("B5").value = comparison.fromDatabase?.length || 0;
            wsSummary.getCell("A6").value = "Only in Excel";
            wsSummary.getCell("B6").value = comparison.onlyInExcel?.length || 0;
            wsSummary.getCell("A7").value = "Only in Database";
            wsSummary.getCell("B7").value = comparison.onlyInDatabase?.length || 0;

            const buffer = await wb.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `GSTR2B_Comparison_${fromDate}_to_${toDate}.xlsx`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);

            setSnackbar({ open: true, message: "Comparison report downloaded.", severity: "success" });
        } catch (err) {
            setSnackbar({
                open: true,
                message: "Export failed: " + err.message,
                severity: "error",
            });
        }
    };


    const exportSourceComparison = async () => {
        if (!sourceComparisonData) return;

        try {
            const wb = new ExcelJS.Workbook();
            const ws = wb.addWorksheet("Source Comparison");

            ws.columns = [
                { header: "Sr.No", key: "srNo", width: 8 },
                { header: "Source", key: "source", width: 12 },
                { header: "Status", key: "status", width: 10 },
                { header: "Reason", key: "reason", width: 20 },
                { header: "Bill No", key: "billNo", width: 12 },
                { header: "Bill Date", key: "billDate", width: 12 },
                { header: "Trade Name", key: "tradeName", width: 25 },
                { header: "GST No", key: "gstNo", width: 15 },
                { header: "Taxable Amt", key: "taxable", width: 12 },
                { header: "IGST", key: "igst", width: 12 },
                { header: "CGST", key: "cgst", width: 12 },
                { header: "SGST", key: "sgst", width: 12 },
                { header: "Cess", key: "cess", width: 12 },
            ];

            ws.getRow(1).font = { bold: true, color: { argb: "FFFFFFFF" } };
            ws.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1B4FBB" } };

            sourceComparisonData.forEach((row, idx) => {
                ws.addRow({
                    srNo: idx + 1,
                    source: row.source,
                    status: row.status,
                    reason: row.reason,
                    billNo: row.billNo,
                    billDate: row.billDate,
                    tradeName: row.tradeName,
                    gstNo: row.gstNo,
                    taxable: row.taxable,
                    igst: row.igst,
                    cgst: row.cgst,
                    sgst: row.sgst,
                    cess: row.cess,
                });
            });

            const buffer = await wb.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `SourceComparison_${fromDate}_to_${toDate}.xlsx`;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(url);

            setSnackbar({ open: true, message: "Comparison report downloaded.", severity: "success" });
        } catch (err) {
            setSnackbar({
                open: true,
                message: "Export failed: " + err.message,
                severity: "error",
            });
        }
    };

    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: PAGE_BG }}>

                {/* Page Header */}
                <Box sx={{
                    background: NAVY, px: { xs: 2, sm: 3 }, py: 1.5,
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    flexWrap: "wrap", gap: 1.5, flexShrink: 0,
                }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <ReceiptLongOutlinedIcon sx={{ fontSize: 18, color: "rgba(255,255,255,0.7)" }} />
                        <Typography sx={{ fontSize: 14, fontWeight: 700, color: WHITE, lineHeight: 1 }}>
                            {getReportLabel()}
                        </Typography>
                    </Box>
                    <Button
                        onClick={() => {
                            if (reportType === "gstr2b" && showSourceComparison && sourceComparisonData) {
                                exportSourceComparison();
                            } else if (reportType === "gstr2b" && gstr2bComparisonData && !showSourceComparison) {
                                exportGSTR2BComparison();
                            } else {
                                handleExportExcel();
                            }
                        }}
                        disabled={(reportType === "gstr2b" && !sourceComparisonData && !gstr2bComparisonData) || (!dataLoaded && validationErrors.length === 0 && reportType !== "gstr2b")}
                        startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 14 }} />}
                        sx={btnHeaderSolid}
                    >
                        Export Excel
                    </Button>
                </Box>

                {/* Filter Card */}
                <Box sx={{ px: { xs: 2, sm: 3 }, pt: "6px", pb: "6px", flexShrink: 0, display: "flex", justifyContent: "center" }}>
                    {reportType === "gstr3b" ? (
                        // ── Compact single-row filter bar (GSTR-3B only) — Report Type,
                        // From Date, To Date and Get Data all in one row, with reduced
                        // vertical padding so the page no longer needs to scroll to
                        // reach the results below. GSTR-1/GSTR-2B keep their original
                        // stacked card layout untouched (see the else-branch below). ──
                        <Box sx={{
                            background: CARD, border: `1px solid ${BORDER}`, borderRadius: "8px",
                            p: "8px", width: "100%",
                            display: "flex", flexDirection: { xs: "column", md: "row" },
                            alignItems: { xs: "stretch", md: "flex-end" }, gap: 1,
                        }}>
                            <Box sx={{ flex: "0 0 180px", minWidth: 150 }}>
                                <Typography sx={{ fontSize: 10.5, color: T2, mb: "3px", fontWeight: 500 }}>Report Type</Typography>
                                <Select
                                    size="small"
                                    fullWidth
                                    disabled
                                    value={reportType}
                                    onChange={(e) => {
                                        setReportType(e.target.value);
                                        setDataLoaded(false);
                                        setGstrData(null);
                                        setShowComparisonTable(false);
                                        setGstr2bComparisonData(null);
                                    }}
                                    sx={{
                                        borderRadius: "4px", fontSize: 13,
                                        "& fieldset": { borderColor: BORDER },
                                        "&:hover fieldset": { borderColor: STEEL },
                                        "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
                                    }}
                                >
                                    {GST_REPORT_OPTIONS.map(o => (
                                        <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                                    ))}
                                </Select>
                            </Box>

                            <Box sx={{ flex: 1, minWidth: 140 }}>
                                <Typography sx={{ fontSize: 10.5, color: T2, mb: "3px", fontWeight: 500 }}>From Date</Typography>
                                <TextField
                                    type="date"
                                    size="small"
                                    fullWidth
                                    value={fromDate}
                                    onChange={(e) => {
                                        setFromDate(e.target.value);
                                        setDataLoaded(false);
                                        setGstrData(null);
                                        setShowComparisonTable(false);
                                    }}
                                    sx={inputSx}
                                />
                            </Box>

                            <Box sx={{ flex: 1, minWidth: 140 }}>
                                <Typography sx={{ fontSize: 10.5, color: T2, mb: "3px", fontWeight: 500 }}>To Date</Typography>
                                <TextField
                                    type="date"
                                    size="small"
                                    fullWidth
                                    value={toDate}
                                    onChange={(e) => {
                                        setToDate(e.target.value);
                                        setDataLoaded(false);
                                        setGstrData(null);
                                        setShowComparisonTable(false);
                                    }}
                                    sx={inputSx}
                                />
                            </Box>

                            <Box sx={{ flex: "0 0 auto", minWidth: { xs: "auto", md: 140 } }}>
                                <Button
                                    onClick={handleGetData}
                                    fullWidth
                                    disabled={loading}
                                    sx={{ ...btnPrimary, height: 33 }}
                                    startIcon={loading ? <CircularProgress size={14} sx={{ color: WHITE }} /> : null}
                                >
                                    {loading ? "Loading..." : "Get Data"}
                                </Button>
                            </Box>
                        </Box>
                    ) : (
                    <Box sx={{
                        background: CARD, border: `1px solid ${BORDER}`, borderRadius: "8px",
                        p: { xs: 2.5, sm: 4 }, width: "100%", maxWidth: 620,
                        display: "flex", flexDirection: "column", gap: 2,
                    }}>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, textTransform: "uppercase", letterSpacing: ".6px" }}>
                            Report Filters
                        </Typography>

                        {/* Report Type */}
                        <Box>
                            <Typography sx={{ fontSize: 11, color: T2, mb: "5px", fontWeight: 500 }}>Report Type</Typography>
                            <Select
                                size="small"
                                fullWidth
                                disabled
                                value={reportType}
                                onChange={(e) => {
                                    setReportType(e.target.value);
                                    setDataLoaded(false);
                                    setGstrData(null);
                                    setShowComparisonTable(false);
                                    setGstr2bComparisonData(null);
                                }}
                                sx={{
                                    borderRadius: "4px", fontSize: 13,
                                    "& fieldset": { borderColor: BORDER },
                                    "&:hover fieldset": { borderColor: STEEL },
                                    "&.Mui-focused fieldset": { borderColor: STEEL, borderWidth: 1.5 },
                                }}
                            >
                                {GST_REPORT_OPTIONS.map(o => (
                                    <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                                ))}
                            </Select>
                        </Box>

                        {/* GSTR-2B Excel Import Section */}
                        {reportType === "gstr2b" && (
                            <Box sx={{
                                border: `2px dashed ${BORDER}`, borderRadius: "6px", p: 2,
                                background: "#f9fafb", textAlign: "center",
                            }}>
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1.5 }}>
                                    <CloudUploadOutlinedIcon sx={{ fontSize: 32, color: STEEL }} />
                                    <Typography sx={{ fontSize: 12, fontWeight: 600, color: T2 }}>
                                        {gstr2bImported ? "✓ Excel Imported Successfully" : "Upload GSTR-2B Excel File"}
                                    </Typography>
                                    <Typography sx={{ fontSize: 11, color: T3, mb: 1 }}>
                                        {gstr2bImportFile ? `File: ${gstr2bImportFile}` : "Select .xlsx file from your computer"}
                                    </Typography>
                                    <input
                                        accept=".xlsx,.xls"
                                        style={{ display: "none" }}
                                        id="gstr2b-upload"
                                        type="file"
                                        onChange={handleGSTR2BFileUpload}
                                        disabled={gstr2bUploading}
                                    />
                                    <label htmlFor="gstr2b-upload" style={{ width: "100%" }}>
                                        <Button
                                            component="span"
                                            disabled={gstr2bUploading}
                                            sx={{
                                                background: gstr2bImported ? "#4CAF50" : STEEL,
                                                color: WHITE,
                                                borderRadius: "4px",
                                                fontSize: 12,
                                                fontWeight: 600,
                                                textTransform: "none",
                                                px: 2,
                                                height: 32,
                                                width: "100%",
                                                "&:hover": { background: gstr2bImported ? "#45a049" : "#1640A0" },
                                                "&:disabled": { background: BORDER, color: T3 },
                                            }}
                                            startIcon={gstr2bUploading ? <CircularProgress size={14} sx={{ color: WHITE }} /> : null}
                                        >
                                            {gstr2bUploading ? "Uploading..." : gstr2bImported ? "✓ Imported" : "Choose File"}
                                        </Button>
                                    </label>
                                    {/* ✅ Auto-delete countdown timer */}
                                    {gstr2bTimeRemaining !== null && gstr2bImportCompId && (
                                        <Box sx={{ mt: 1, p: 1, bgcolor: '#FFF3CD', borderRadius: 1, border: '1px solid #FFC107' }}>
                                            <Typography sx={{ fontSize: 11, color: '#856404', fontWeight: 500 }}>
                                                ⏱️ Auto-delete in {Math.floor(gstr2bTimeRemaining / 60)}:{String(gstr2bTimeRemaining % 60).padStart(2, '0')} min
                                            </Typography>
                                            <Typography sx={{ fontSize: 9, color: '#856404', mt: 0.5 }}>
                                                Imported data will be automatically deleted for security.
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        )}


                        {/* From Date & To Date */}
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
                            <Box>
                                <Typography sx={{ fontSize: 11, color: T2, mb: "5px", fontWeight: 500 }}>From Date</Typography>
                                <TextField
                                    type="date"
                                    size="small"
                                    fullWidth
                                    value={fromDate}
                                    onChange={(e) => {
                                        setFromDate(e.target.value);
                                        setDataLoaded(false);
                                        setGstrData(null);
                                        setShowComparisonTable(false);
                                    }}
                                    sx={inputSx}
                                />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 11, color: T2, mb: "5px", fontWeight: 500 }}>To Date</Typography>
                                <TextField
                                    type="date"
                                    size="small"
                                    fullWidth
                                    value={toDate}
                                    onChange={(e) => {
                                        setToDate(e.target.value);
                                        setDataLoaded(false);
                                        setGstrData(null);
                                        setShowComparisonTable(false);
                                    }}
                                    sx={inputSx}
                                />
                            </Box>
                        </Box>

                        {/* Get Data Button - Different for GSTR-2B */}
                        {reportType === "gstr2b" ? (
                            <Button
                                onClick={handleGSTR2BComparison}
                                fullWidth
                                disabled={loading || !gstr2bImported}
                                sx={btnPrimary}
                                startIcon={loading ? <CircularProgress size={14} sx={{ color: WHITE }} /> : null}
                            >
                                {loading ? "Comparing..." : "Compare Data"}
                            </Button>
                        ) : (
                            <Button
                                onClick={handleGetData}
                                fullWidth
                                disabled={loading}
                                sx={btnPrimary}
                                startIcon={loading ? <CircularProgress size={14} sx={{ color: WHITE }} /> : null}
                            >
                                {loading ? "Loading..." : "Get Data"}
                            </Button>
                        )}

                    </Box>
                    )}
                </Box>

                {/* Content Area */}
                <Box sx={{ px: { xs: 2, sm: 3 }, pt: 0, pb: 3 }}>
                    {showErrorDownload && (
                        <Box sx={{
                            background: CARD, border: `2px solid #D32F2F`, borderRadius: "8px",
                            p: 2.5, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 2,
                        }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography sx={{ fontSize: 13, color: "#D32F2F", fontWeight: 600, mb: 0.5 }}>
                                    ⚠️ Validation Errors Found
                                </Typography>
                                <Typography sx={{ fontSize: 12, color: T2 }}>
                                    {validationErrors.length} error(s) detected. Download error report below.
                                </Typography>
                            </Box>
                            <Button
                                onClick={generateErrorExcel}
                                sx={{
                                    background: "#D32F2F", color: WHITE, borderRadius: "4px", fontSize: 12, fontWeight: 600,
                                    textTransform: "none", px: 2, height: 36, whiteSpace: "nowrap",
                                    "&:hover": { background: "#B71C1C" },
                                }}
                            >
                                Download Error Report
                            </Button>
                        </Box>
                    )}

                    {/* Extend Timer Button - Show when popup is closed */}
                    {gstr2bImported && gstr2bImportCompId && showExtendTimerButton && (
                        <Box sx={{ position: "fixed", bottom: 30, right: 30, zIndex: 90 }}>
                            <Button
                                onClick={() => setShowTimerExtensionPopup(true)}
                                sx={{
                                    background: "#FF9800", color: WHITE, borderRadius: "50%",
                                    width: 60, height: 60, minWidth: 60, padding: 0,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontSize: 12, fontWeight: 600, boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                    "&:hover": { background: "#F57C00" },
                                }}
                            >
                                ⏱️
                            </Button>
                        </Box>
                    )}

                    {/* GSTR-2B Comparison Table */}
                    {reportType === "gstr2b" && showSourceComparison && sourceComparisonData && sourceComparisonData.length > 0 && (
                        <Box sx={{ mb: 3 }}>
                            {/* Summary cards */}
                            {gstr2bComparisonData?.summary && (
                                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 1.5, mb: 2 }}>
                                    <Paper sx={{ p: 1.5, borderLeft: "4px solid #4CAF50" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Fully Matched</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#4CAF50" }}>{gstr2bComparisonData.summary.fullyMatched || 0}</Typography>
                                    </Paper>
                                    {/* <Paper sx={{ p: 1.5, borderLeft: "4px solid #FF9800" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>With Differences</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#FF9800" }}>{gstr2bComparisonData.summary.withDifferences || 0}</Typography>
                                    </Paper>
                                    <Paper sx={{ p: 1.5, borderLeft: "4px solid #F44336" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Not in Reon</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#F44336" }}>{gstr2bComparisonData.onlyInExcel?.length || 0}</Typography>
                                    </Paper>
                                    <Paper sx={{ p: 1.5, borderLeft: "4px solid #FFB300" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Not in Portal</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#FFB300" }}>{gstr2bComparisonData.onlyInDatabase?.length || 0}</Typography>
                                    </Paper> */}
                                    <Paper sx={{ p: 1.5, borderLeft: "4px solid #4472C4" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Portal Records</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#4472C4" }}>{gstr2bComparisonData.summary.totalImported || 0}</Typography>
                                    </Paper>
                                    <Paper sx={{ p: 1.5, borderLeft: "4px solid #70AD47" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Reon Records</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#70AD47" }}>{gstr2bComparisonData.summary.totalInDatabase || 0}</Typography>
                                    </Paper>
                                </Box>
                            )}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1 }}>
                                    GSTR-2B Reconciliation ({sourceComparisonData.length} records)
                                </Typography>
                            </Box>
                            <TableContainer component={Paper} sx={{ maxHeight: "700px", overflow: "auto" }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "45px" }}>Sr.No</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "80px" }}>Source</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "75px" }}>Status</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "160px" }}>Reason</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "90px" }}>Bill No</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "90px" }}>Bill Date</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "150px" }}>Trade Name</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "130px" }}>GSTIN</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "100px" }} align="right">Taxable Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "85px" }} align="right">IGST Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "85px" }} align="right">CGST Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "85px" }} align="right">SGST Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "85px" }} align="right">Cess Amt</TableCell>
                                            <TableCell sx={{ fontWeight: 700, color: WHITE, backgroundColor: NAVY, width: "110px" }} align="center">Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sourceComparisonData.map((row, idx) => {
                                            const rowBg =
                                                row.source === "Matched" ? "#F0FFF0" :
                                                    row.source === "Portal" ? "#FFF0F0" : "#FFFDE7";
                                            const fmtAmt = (v) => v != null ? Number(v).toFixed(2) : "-";
                                            const chipColor =
                                                row.source === "Matched" ? { bg: "#C8E6C9", fg: "#2E7D32" } :
                                                    row.source === "Portal" ? { bg: "#FFCDD2", fg: "#C62828" } :
                                                        { bg: "#FFE0B2", fg: "#BF360C" };
                                            return (
                                                <TableRow key={idx} hover sx={{ backgroundColor: rowBg }}>
                                                    <TableCell sx={{ fontSize: 11 }}>{idx + 1}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }}>
                                                        <Chip label={row.source} size="small" sx={{ background: chipColor.bg, color: chipColor.fg, fontWeight: 600, fontSize: 10 }} />
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: 11 }}>{row.status}</TableCell>
                                                    <TableCell sx={{ fontSize: 10, color: row.reason ? "#C62828" : T3, fontWeight: row.reason ? 600 : 400 }}>
                                                        {row.reason || "-"}
                                                    </TableCell>
                                                    <TableCell sx={{ fontSize: 11 }}>{row.billNo || "-"}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }}>{row.billDate || "-"}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }}>{row.tradeName || "-"}</TableCell>
                                                    <TableCell sx={{ fontSize: 10 }}>{row.gstNo || "-"}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }} align="right">{fmtAmt(row.taxable)}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }} align="right">{fmtAmt(row.igst)}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }} align="right">{fmtAmt(row.cgst)}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }} align="right">{fmtAmt(row.sgst)}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }} align="right">{fmtAmt(row.cess)}</TableCell>
                                                    <TableCell sx={{ fontSize: 11 }} align="center">
                                                        {row.source === "Portal" && !postedRecordKeys.has(`${row.gstNo}|${row.billNo}`) && (
                                                            <Button
                                                                size="small"
                                                                disabled={insertingRecordKey === `${row.gstNo}|${row.billNo}`}
                                                                onClick={() => handleInsertRecordInReon(row)}
                                                                sx={{
                                                                    fontSize: 10, textTransform: "none", fontWeight: 600,
                                                                    color: WHITE, background: STEEL, borderRadius: "4px",
                                                                    px: 1, py: "2px", minWidth: 0,
                                                                    "&:hover": { background: "#1640A0" },
                                                                }}
                                                            >
                                                                {insertingRecordKey === `${row.gstNo}|${row.billNo}`
                                                                    ? <CircularProgress size={12} sx={{ color: WHITE }} />
                                                                    : "+ Add to Reon"}
                                                            </Button>
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    )}

                    {/* GSTR-2B Comparison Summary - Only show if NOT showing source comparison */}
                    {reportType === "gstr2b" && gstr2bComparisonData && !showSourceComparison && (
                        <>
                            {!showSourceComparison && (
                                <Box sx={{ mb: 2, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 1.5 }}>
                                    <Paper sx={{ p: 2, borderLeft: "4px solid #4472C4" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Imported Records</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#4472C4" }}>
                                            {gstr2bComparisonData.imported?.length || 0}
                                        </Typography>
                                    </Paper>
                                    <Paper sx={{ p: 2, borderLeft: "4px solid #70AD47" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Database Records</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#70AD47" }}>
                                            {gstr2bComparisonData.fromDatabase?.length || 0}
                                        </Typography>
                                    </Paper>
                                    <Paper sx={{ p: 2, borderLeft: "4px solid #FF6B6B" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Not in Reon</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#FF6B6B" }}>
                                            {gstr2bComparisonData.onlyInExcel?.length || 0}
                                        </Typography>
                                    </Paper>
                                    <Paper sx={{ p: 2, borderLeft: "4px solid #FFB300" }}>
                                        <Typography sx={{ fontSize: 11, color: T3 }}>Not in Portal</Typography>
                                        <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#FFB300" }}>
                                            {gstr2bComparisonData.onlyInDatabase?.length || 0}
                                        </Typography>
                                    </Paper>
                                </Box>
                            )}

                            {/* Comparison Tables - Only show when not showing source comparison */}
                            {gstr2bComparisonData.onlyInExcel && gstr2bComparisonData.onlyInExcel.length > 0 && !showSourceComparison && (
                                <Box sx={{ mb: 3 }}>
                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, mb: 1 }}>
                                        Not in Reon — Portal Only ({gstr2bComparisonData.onlyInExcel.length})
                                    </Typography>
                                    <TableContainer component={Paper}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ background: "#FF6B6B" }}>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>GSTIN</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>Supplier</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>Invoice #</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>Date</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }} align="right">Value</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {gstr2bComparisonData.onlyInExcel.map((row, idx) => (
                                                    <TableRow key={idx} hover>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.GSTINOfSupplier}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.TradeLegalName}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.InvoiceNumber}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.InvoiceDate?.toString().slice(0, 10)}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }} align="right">{Number(row.InvoiceValue).toFixed(2)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )}

                            {gstr2bComparisonData.onlyInDatabase && gstr2bComparisonData.onlyInDatabase.length > 0 && !showSourceComparison && (
                                <Box sx={{ mb: 3 }}>
                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, mb: 1 }}>
                                        Not in Portal — Reon Only ({gstr2bComparisonData.onlyInDatabase.length})
                                    </Typography>
                                    <TableContainer component={Paper}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ background: "#FFB300" }}>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>GSTIN</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>Supplier</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>Invoice #</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }}>Date</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: WHITE }} align="right">Value</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {gstr2bComparisonData.onlyInDatabase.map((row, idx) => (
                                                    <TableRow key={idx} hover>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.GSTNo}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.SupplierName}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.InvoiceNumber}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }}>{row.InvoiceDate?.toString().slice(0, 10)}</TableCell>
                                                        <TableCell sx={{ fontSize: 12 }} align="right">{Number(row.InvoiceValue).toFixed(2)}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )}
                        </>
                    )}

                    {/* GSTR-3B "GST SETOFF" summary grid — matches the reference design
                        (Op. Bal / Inward Supply / Total Input Credit / Op. Bal / Outward
                        Supply / Total Output Liability / Cl. Bal, plus the IGST/CGST/SGST/
                        CESS cross-setoff matrix and Liability to be Paid / Credit Receivable).
                        Purely additive — does not touch GSTR-1/GSTR-2B rendering, handleGetData,
                        or doExportExcel/addGSTR3BSheet in any way. */}
                    {dataLoaded && reportType === "gstr3b" && gstrData && (() => {
                        // Prefer the backend's ledger-based setoff (data.setoff_ledger —
                        // direct port of the legacy VB.NET pGSTJV_NEW logic: opening
                        // balances from clientmaster.OPBAL + pre-period g_ledgerbook
                        // movement, then current-period SALE/CRNT vs PURC/DBNT movement,
                        // then the exact case-based cross-setoff cascade). Falls back to
                        // the older report-section-only computeGSTR3BSetoff() when the
                        // backend hasn't been redeployed yet, so nothing breaks either way.
                        const L = gstrData.setoff_ledger;
                        const setoff = L
                            ? {
                                inputCredit: L.totalInputCredit,
                                outputLiability: L.totalOutputLiability,
                                setoff: {
                                    IGST: { IGST: L.setoffChart.igstToIgst, CGST: L.setoffChart.igstToCgst, SGST: L.setoffChart.igstToSgst, Cess: 0 },
                                    CGST: { IGST: L.setoffChart.cgstToIgst, CGST: L.setoffChart.cgstToCgst, SGST: 0, Cess: 0 },
                                    SGST: { IGST: L.setoffChart.sgstToIgst, CGST: 0, SGST: L.setoffChart.sgstToSgst, Cess: 0 },
                                    Cess: { IGST: 0, CGST: 0, SGST: 0, Cess: L.setoffChart.cessToCess },
                                },
                                liabilityToBePaid: L.liabilityToBePaid,
                                creditReceivable: L.creditReceivable,
                                totalPayable: L.totalPayable,
                                totalReceivable: L.totalReceivable,
                                // Real opening balance / period-movement / closing-balance
                                // figures (VB's txtClBalX) for the previously-placeholder
                                // Op.Bal/Inward/Outward Supply/Closing Bal. columns.
                                openingBalance: L.openingBalance,
                                periodMovement: L.periodMovement,
                                closingBalance: L.closingBalance,
                            }
                            : computeGSTR3BSetoff(gstrData);
                        const hasLedgerSetoff = !!L;
                        const fmt = (v) => (Number(v) ? Number(v).toFixed(2) : "—");
                        const HEADS = ["IGST", "CGST", "SGST", "Cess"];
                        const HEAD_LABELS = { IGST: "IGST", CGST: "CGST", SGST: "SGST / UTGST", Cess: "CESS" };
                        const HEAD_DOT = { IGST: "#7C3AED", CGST: "#0EA5E9", SGST: "#F59E0B", Cess: "#EC4899" };

                        // ── Palette — softer, more legible tints with a matching border/text pair per role ──
                        const TONE = {
                            neutral: { bg: WHITE, border: BORDER, text: T1 },
                            credit: { bg: "#EAF7EC", border: "#BFE6C6", text: "#1B7A3D" },
                            liability: { bg: "#FFF8E1", border: "#F3E0A0", text: "#8A6D1B" },
                            settle: { bg: "#FDF1FB", border: "#F0CBEA", text: "#9C1E8A" },
                            disabled: { bg: "#F1F2F4", border: "#E2E4E8", text: T3 },
                            // Cells with no backing data source yet (e.g. Op.Bal/Inward/Outward
                            // Supply columns) — a dashed border + centered dash reads as "not
                            // tracked yet", distinct from a genuinely blank/broken field.
                            placeholder: { bg: "#FAFAFB", border: "#E2E4E8", text: "#C7C9CE" },
                            payable: { bg: "#FFE9D6", border: "#F4C08E", text: "#9A4E0A" },
                            receivable: { bg: "#1F8A47", border: "#1F8A47", text: WHITE },
                        };
                        const cellSx = (tone, extra = {}) => ({
                            background: tone.bg,
                            border: `1px ${tone === TONE.placeholder ? "dashed" : "solid"} ${tone.border}`,
                            borderRadius: "5px",
                            px: 1, py: "4px", fontSize: 12, fontWeight: 600, color: tone.text,
                            textAlign: tone === TONE.placeholder ? "center" : "right",
                            minHeight: 16, lineHeight: 1.5, transition: "box-shadow .15s ease",
                            ...extra,
                        });
                        const colHeaderSx = {
                            fontSize: 9.5, fontWeight: 700, color: T3, textAlign: "center",
                            textTransform: "uppercase", letterSpacing: "0.3px", lineHeight: 1.2,
                        };
                        const rowLabelSx = (head) => ({
                            fontSize: 12, fontWeight: 700, color: T1, display: "flex",
                            alignItems: "center", gap: "6px",
                            "&::before": {
                                content: '""', width: 6, height: 6, borderRadius: "50%",
                                background: HEAD_DOT[head], flexShrink: 0,
                            },
                        });

                        return (
                            <Box sx={{
                                background: CARD, border: `1px solid ${BORDER}`, borderRadius: "8px",
                                boxShadow: "0 1px 3px rgba(15,23,42,0.06)", overflow: "hidden", mb: 1.5,
                            }}>
                                {/* ── Section header ── */}
                                <Box sx={{
                                    display: "flex", alignItems: "center", gap: 1, px: 2, py: 1,
                                    background: `linear-gradient(135deg, ${STEEL} 0%, #143C8F 100%)`,
                                }}>
                                    <Box sx={{
                                        width: 24, height: 24, borderRadius: "6px", background: "rgba(255,255,255,0.16)",
                                        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                                    }}>
                                        <ReceiptLongOutlinedIcon sx={{ fontSize: 14, color: WHITE }} />
                                    </Box>
                                    <Box>
                                        <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: WHITE, lineHeight: 1.2 }}>
                                            GST Setoff Summary
                                        </Typography>
                                        <Typography sx={{ fontSize: 9.5, color: "rgba(255,255,255,0.75)", lineHeight: 1.2 }}>
                                            Input tax credit adjustment against output liability
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ p: { xs: 1, sm: 1.25 }, pb: { xs: "6px", sm: "8px" } }}>
                                    {/* ── Top block: Op.Bal (Inward) / Inward Supply / Total Input Credit /
                                        Op. Bal / Outward Supply / Total Output Liability / Closing Bal.
                                        The Op.Bal/Inward/Outward Supply columns have no backing data source in
                                        gstrData yet, so their cells render as a clean dashed placeholder (not a
                                        raw empty box) rather than a broken-looking blank field. ── */}
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: "0.4px", mb: "6px" }}>
                                        Input Credit &amp; Output Liability
                                    </Typography>
                                    <Box sx={{
                                        display: "grid", gridTemplateColumns: "100px repeat(7, 1fr)", gap: "6px",
                                        alignItems: "center", mb: 1.5, overflowX: "auto",
                                    }}>
                                        <Box />
                                        {["Op. Bal (Inward)", "Inward Supply", "Total Input Credit", "Op. Bal", "Outward Supply", "Total Output Liability", "Closing Bal."].map((h) => (
                                            <Typography key={h} sx={colHeaderSx}>{h}</Typography>
                                        ))}

                                        {HEADS.map((head) => {
                                            // VB's txtClBalX when the real ledger-based setoff data is
                                            // available; otherwise the same output-minus-input approximation
                                            // used before the backend provided real closing balances.
                                            const closingBal = hasLedgerSetoff
                                                ? Number(setoff.closingBalance?.[head]) || 0
                                                : (Number(setoff.outputLiability[head]) || 0) - (Number(setoff.inputCredit[head]) || 0);
                                            const opBalInward = hasLedgerSetoff ? Number(setoff.openingBalance[head]?.purc) || 0 : null;
                                            const opBalOutward = hasLedgerSetoff ? Number(setoff.openingBalance[head]?.sale) || 0 : null;
                                            const inwardSupply = hasLedgerSetoff ? Number(setoff.periodMovement[head]?.purc) || 0 : null;
                                            const outwardSupply = hasLedgerSetoff ? Number(setoff.periodMovement[head]?.sale) || 0 : null;
                                            return (
                                                <React.Fragment key={head}>
                                                    <Typography sx={rowLabelSx(head)}>{HEAD_LABELS[head]}</Typography>
                                                    {hasLedgerSetoff ? (
                                                        <Box sx={cellSx(TONE.neutral)}>{fmt(opBalInward)}</Box>
                                                    ) : (
                                                        <Box sx={cellSx(TONE.placeholder)}>–</Box>
                                                    )}
                                                    {hasLedgerSetoff ? (
                                                        <Box sx={cellSx(TONE.neutral)}>{fmt(inwardSupply)}</Box>
                                                    ) : (
                                                        <Box sx={cellSx(TONE.placeholder)}>–</Box>
                                                    )}
                                                    <Box sx={cellSx(TONE.credit)}>{fmt(setoff.inputCredit[head])}</Box>
                                                    {hasLedgerSetoff ? (
                                                        <Box sx={cellSx(TONE.neutral)}>{fmt(opBalOutward)}</Box>
                                                    ) : (
                                                        <Box sx={cellSx(TONE.placeholder)}>–</Box>
                                                    )}
                                                    {hasLedgerSetoff ? (
                                                        <Box sx={cellSx(TONE.neutral)}>{fmt(outwardSupply)}</Box>
                                                    ) : (
                                                        <Box sx={cellSx(TONE.placeholder)}>–</Box>
                                                    )}
                                                    <Box sx={cellSx(TONE.liability)}>{fmt(setoff.outputLiability[head])}</Box>
                                                    <Box sx={cellSx(TONE.settle)}>{fmt(closingBal)}</Box>
                                                </React.Fragment>
                                            );
                                        })}
                                    </Box>

                                    {/* ── Bottom block: cross-setoff matrix ── */}
                                    <Typography sx={{ fontSize: 10, fontWeight: 700, color: T2, textTransform: "uppercase", letterSpacing: "0.4px", mb: "6px" }}>
                                        Credit Utilization Matrix
                                    </Typography>
                                    <Box sx={{
                                        display: "grid", gridTemplateColumns: "100px 1fr repeat(4, 1fr) 1fr 1fr", gap: "6px",
                                        alignItems: "center", mb: 1.5, overflowX: "auto",
                                    }}>
                                        <Box />
                                        <Typography sx={colHeaderSx}>Output Liability</Typography>
                                        {HEADS.map((h) => (
                                            <Typography key={h} sx={colHeaderSx}>{HEAD_LABELS[h]}</Typography>
                                        ))}
                                        <Typography sx={colHeaderSx}>Payable</Typography>
                                        <Typography sx={colHeaderSx}>Receivable</Typography>

                                        {HEADS.map((rowHead) => (
                                            <React.Fragment key={rowHead}>
                                                <Typography sx={rowLabelSx(rowHead)}>{HEAD_LABELS[rowHead]}</Typography>
                                                <Box sx={cellSx(TONE.liability)}>{fmt(setoff.outputLiability[rowHead])}</Box>
                                                {HEADS.map((colHead) => {
                                                    const usable = (rowHead === "IGST" && ["IGST", "CGST", "SGST"].includes(colHead))
                                                        || (rowHead === "CGST" && ["CGST", "IGST"].includes(colHead))
                                                        || (rowHead === "SGST" && ["SGST", "IGST"].includes(colHead))
                                                        || (rowHead === "Cess" && colHead === "Cess");
                                                    return (
                                                        <Box key={colHead} sx={cellSx(usable ? TONE.credit : TONE.disabled, !usable ? { color: "#D1D3D8", fontWeight: 400, textAlign: "center" } : {})}>
                                                            {usable ? fmt(setoff.setoff[rowHead][colHead]) : "–"}
                                                        </Box>
                                                    );
                                                })}
                                                <Box sx={cellSx(TONE.settle)}>{fmt(setoff.liabilityToBePaid[rowHead])}</Box>
                                                <Box sx={cellSx(TONE.settle)}>{fmt(setoff.creditReceivable[rowHead])}</Box>
                                            </React.Fragment>
                                        ))}
                                    </Box>

                                    {/* ── Totals strip ── */}
                                    <Box sx={{
                                        display: "flex", gap: 1, mb: "8px", flexWrap: "wrap",
                                    }}>
                                        <Box sx={{
                                            flex: "1 1 220px", display: "flex", alignItems: "center", justifyContent: "space-between",
                                            ...cellSx(TONE.payable, { borderRadius: "7px", px: 1.5, py: "8px" }),
                                        }}>
                                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: "inherit", textTransform: "uppercase", letterSpacing: "0.3px" }}>
                                                Total Payable
                                            </Typography>
                                            <Typography sx={{ fontSize: 15, fontWeight: 800, color: "inherit" }}>
                                                {fmt(setoff.totalPayable)}
                                            </Typography>
                                        </Box>
                                        <Box sx={{
                                            flex: "1 1 220px", display: "flex", alignItems: "center", justifyContent: "space-between",
                                            ...cellSx(TONE.receivable, { borderRadius: "7px", px: 1.5, py: "8px" }),
                                        }}>
                                            <Typography sx={{ fontSize: 11, fontWeight: 700, color: "inherit", textTransform: "uppercase", letterSpacing: "0.3px" }}>
                                                Total Receivable
                                            </Typography>
                                            <Typography sx={{ fontSize: 15, fontWeight: 800, color: "inherit" }}>
                                                {fmt(setoff.totalReceivable)}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* ── Settlement fields ── */}
                                    <Box sx={{
                                        display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1.4fr 0.8fr 0.8fr auto" },
                                        gap: 1, alignItems: "end", pt: "6px", borderTop: `1px dashed ${BORDER}`,
                                    }}>
                                        <Box>
                                            <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: T2, mb: "2px" }}>GST Payable A/c</Typography>
                                            <Autocomplete
                                                size="small"
                                                fullWidth
                                                options={gstPayableAcOptions}
                                                loading={gstPayableAcLoading}
                                                value={gstPayableAcSelected}
                                                onChange={(e, newValue) => setGstPayableAcSelected(newValue)}
                                                inputValue={gstPayableAcInput}
                                                onInputChange={(e, newInputValue) => setGstPayableAcInput(newInputValue)}
                                                getOptionLabel={(o) => o?.label || ""}
                                                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        placeholder="Select GST Payable Ledger A/c"
                                                        sx={inputSx}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <>
                                                                    {gstPayableAcLoading ? <CircularProgress size={14} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Box>
                                        <Box>
                                            <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: T2, mb: "2px" }}>Date</Typography>
                                            <TextField type="date" size="small" fullWidth sx={inputSx} value={toDate} disabled />
                                        </Box>
                                        <Box>
                                            <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: T2, mb: "2px" }}>JV No.</Typography>
                                            <TextField size="small" fullWidth placeholder="Auto" sx={inputSx} disabled />
                                        </Box>
                                        <Button
                                            sx={{ ...btnPrimary, height: 32 }}
                                            disabled={savingSetoffJV}
                                            onClick={() => handleSaveGSTR3BJV(setoff.liabilityToBePaid, setoff.totalPayable, L?.setoffChart)}
                                        >
                                            {savingSetoffJV ? <CircularProgress size={14} sx={{ color: WHITE }} /> : "Save"}
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        );
                    })()}

                    {dataLoaded && reportType !== "gstr2b" && reportType !== "gstr3b" && (
                        <Box sx={{
                            background: CARD, border: `1px solid ${BORDER}`, borderRadius: "8px",
                            p: 2.5, display: "flex", alignItems: "center", justifyContent: "center", gap: 1,
                        }}>
                            <FileDownloadOutlinedIcon sx={{ fontSize: 18, color: STEEL }} />
                            <Typography sx={{ fontSize: 13, color: T2 }}>
                                Data ready — click <strong>Export Excel</strong> in the header to download.
                            </Typography>
                        </Box>
                    )}
                </Box>

            </Box>

            {/* Timer Extension Dialog */}
            <Dialog
                open={showTimerExtensionPopup}
                onClose={() => {
                    setShowTimerExtensionPopup(false);
                    setShowExtendTimerButton(true);
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 700, color: T1, background: "#FFF3E0", borderBottom: `2px solid #FF9800` }}>
                    ⏱️ Extend Auto-Delete Timer
                </DialogTitle>
                <DialogContent sx={{ mt: 2 }}>
                    <Typography sx={{ fontSize: 13, color: T2, mb: 1 }}>
                        Your imported data will be automatically deleted in <strong>{gstr2bTimeRemaining}s</strong>.
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: T3, mb: 2 }}>
                        Would you like to extend the deletion timer?
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Button
                            onClick={() => handleExtendTimer(10)}
                            variant="contained"
                            sx={{
                                background: "#2196F3", color: WHITE, textTransform: "none",
                                fontSize: 12, fontWeight: 600, py: 1.5,
                                "&:hover": { background: "#1976D2" },
                            }}
                        >
                            ✓ Extend by 10 Minutes
                        </Button>
                        <Button
                            onClick={() => handleExtendTimer(20)}
                            variant="contained"
                            sx={{
                                background: "#4CAF50", color: WHITE, textTransform: "none",
                                fontSize: 12, fontWeight: 600, py: 1.5,
                                "&:hover": { background: "#45a049" },
                            }}
                        >
                            ✓ Extend by 20 Minutes
                        </Button>
                        <Button
                            onClick={() => handleExtendTimer(25)}
                            variant="contained"
                            sx={{
                                background: "#9C27B0", color: WHITE, textTransform: "none",
                                fontSize: 12, fontWeight: 600, py: 1.5,
                                "&:hover": { background: "#7B1FA2" },
                            }}
                        >
                            ✓ Extend by 25 Minutes
                        </Button>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ gap: 1, px: 3, pb: 2, pt: 1 }}>
                    <Button
                        onClick={() => {
                            setShowTimerExtensionPopup(false);
                            setShowExtendTimerButton(true);
                        }}
                        sx={{ color: T2, textTransform: "none", fontWeight: 600 }}
                    >
                        Close (Don't Extend)
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Download Warning Dialog */}
            <Dialog open={showWarningDialog} onClose={() => setShowWarningDialog(false)}>
                <DialogTitle sx={{ fontWeight: 700, color: T1 }}>
                    ⚠️ Download Excel File
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ fontSize: 13, color: T2, mt: 1 }}>
                        Do you really want to download the Excel file?
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
                    <Button
                        onClick={() => setShowWarningDialog(false)}
                        sx={{ color: T2, textTransform: "none" }}
                    >
                        No
                    </Button>
                    <Button
                        onClick={() => {
                            setShowWarningDialog(false);
                            doExportExcel();
                        }}
                        sx={{
                            background: STEEL, color: WHITE, borderRadius: "4px", textTransform: "none",
                            "&:hover": { background: "#1640A0" },
                        }}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            {/* GSTR-3B Setoff JV override-confirm dialog — shown when the backend
                reports an existing JV for this company/financial year (409
                confirmationRequired), mirroring the Depreciation JV's confirm flow. */}
            <Dialog open={setoffJvOverrideConfirm.open} onClose={() => setSetoffJvOverrideConfirm({ open: false, message: "", args: null })}>
                <DialogTitle sx={{ fontWeight: 700, color: T1 }}>
                    ⚠️ Existing GSTR-3B Setoff JV Found
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ fontSize: 13, color: T2, mt: 1 }}>
                        {setoffJvOverrideConfirm.message}
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ gap: 1, px: 3, pb: 2 }}>
                    <Button
                        onClick={() => setSetoffJvOverrideConfirm({ open: false, message: "", args: null })}
                        sx={{ color: T2, textTransform: "none" }}
                    >
                        No
                    </Button>
                    <Button
                        onClick={() => {
                            const { liabilityToBePaid, totalPayable, setoffChart } = setoffJvOverrideConfirm.args || {};
                            setSetoffJvOverrideConfirm({ open: false, message: "", args: null });
                            handleSaveGSTR3BJV(liabilityToBePaid, totalPayable, setoffChart, true);
                        }}
                        sx={{
                            background: STEEL, color: WHITE, borderRadius: "4px", textTransform: "none",
                            "&:hover": { background: "#1640A0" },
                        }}
                    >
                        Yes, Override
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3500}
                onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar(s => ({ ...s, open: false }))} sx={{ fontSize: 13 }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}